import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneClean = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"type": "page",
			"properties": {
				"title": [
					[
						"Пишем чисто"
					]
				]
			},
			"content": [
				"59965235-a5bf-47ab-a373-a550ce0256e7",
				"b7864cd6-2e21-495a-9b51-ae4ed7f1f1fd",
				"d7e9841d-e443-46e2-aa0e-9402858b354f",
				"9f93f6a4-3fec-4750-8245-970686bf8f86",
				"03a33099-5dce-4628-a0a5-ca3b9dc3abad",
				"c3fef077-54fe-4d08-af50-568d719ca68c",
				"8ce4e5bd-65a9-4fa3-b0d3-00eff3d811d1",
				"e9347113-ed15-46f5-9cd0-d52a24a79929",
				"1ff6cd3c-4b8a-43dd-9d17-1693afc49b74",
				"97879833-bc33-4b6e-8c5a-6fe6595c6186",
				"79dfd380-cd00-48e4-a168-92c5e76075ed",
				"bb6c534d-7478-43d9-95fe-21ad6617e3e5",
				"65b828a2-444b-4c12-a9ed-3e6fcf35e67d",
				"72dbb176-2061-45e5-a285-ab07dc3a0b34",
				"d8ab1bfa-fbcd-4825-ba77-43e3a7d9c299",
				"69898a5f-09e5-4896-b3c4-93d31b5f201e",
				"fc91a676-d576-4f21-a357-4e6d233a8fbf",
				"e46e86f7-a33e-4fca-bfc3-0b05acab0a2c",
				"c242c9d8-02ce-4ae6-bd7e-51916efd3236",
				"336ba265-3427-4de7-93b4-958d942905fb",
				"4da46509-d00b-41e0-9f76-d74f9f8c9779",
				"5729a417-7752-44c8-a863-9718b6206f2c",
				"cfe42ae5-a78a-4905-bc5c-2ba752b0cd92",
				"fd60ce87-d028-4055-a11e-10cf83463ae1",
				"60ba7901-50ef-4813-a599-8ecb40cae7fb",
				"5f972338-11af-4890-9175-893cfc5f6d22",
				"84e84070-0c46-4c0c-91ae-e48f6facd637",
				"f4bc694b-2967-4c38-86eb-4b51040032c7",
				"5bd5d568-6210-42bb-a6fe-299662ecdcdc",
				"d7ce3ea4-e486-4f6f-bd0f-15045e914560",
				"72305868-915b-40f9-af46-c2b1a09b74b1",
				"2fe07a5a-dea5-4c5c-bd4f-9cf8dfa2fcdb",
				"201a2496-d2f3-4a51-a5f8-1f068b070aef",
				"fd526106-ee6f-49de-a869-aa3987e2c4d6",
				"d4a32e28-a992-4d3f-9252-7031a22aad80",
				"97699c60-5380-467f-b7e4-4092482f5104",
				"fcb4c0b6-e902-4e2c-bb77-de5501c37a5b",
				"b2e127e0-3eee-4b98-be4d-760ac17c98ef",
				"ce7e9edd-23a4-4efb-b46f-ebb21021e194",
				"600c1638-d6b0-4442-8305-e3c0162640b1",
				"06178e39-bc91-4360-9718-d076baa1e364",
				"bf82f73e-1366-4c0b-8ca8-b263cb901667",
				"36fdc020-b5af-4264-9586-f4961df1e1f9",
				"9c02599b-abb3-4aaf-86e0-29ea44ad1d44",
				"a580c6f5-c985-42a4-9e1f-f06b21f4b19c",
				"6acba627-0f84-4489-8fac-6583370b7a25",
				"faa5eced-f21b-440f-856f-fe05315dab5b",
				"d08496d1-e38e-42f4-913f-0281d63418d1",
				"c04e4823-161d-4a36-95fb-73cfbd342d57",
				"f11d7112-24c3-4317-ac25-b44501cdcd6b",
				"3a315020-4d58-476b-bacb-bdf18f9eafa5",
				"6ee5d949-c739-4f2f-a6a1-e44fcd1e0a35",
				"f204f905-a50d-4e58-826d-b92f5287368f",
				"e5cc036e-ded8-4ab5-9e5f-96f051baa10c",
				"9c97b9fb-099e-40cc-b72e-c4a5281c1095",
				"a4c78281-b97b-4895-ae64-85d23d819db0",
				"b203b4be-228f-4b22-973a-ef6b96350f73",
				"3b047bbb-a4b9-42b9-a028-857492f28303",
				"64b4e3a9-12a0-4701-a531-9ebbf7b4796e",
				"21afbd22-0224-4a01-a6e1-fc485ca5cb38",
				"cfe08ee8-6d71-489a-956a-6f90ab270a7a",
				"8b4af153-2cce-4ece-bd13-9a37266c638b",
				"884632f9-6153-41f8-bf9c-1d2b8250d543",
				"c55dac27-cfad-4ad2-8984-09733b23f351",
				"908edd23-6be6-456b-98a4-cb7742ca4020",
				"f24c9c4b-055c-4f15-bdac-d2d85e2dc5f5",
				"fc01368d-78f1-4394-b0ec-89f6e4f8b601",
				"8b78f2a0-2e0e-4095-bbe1-0c11171217fa",
				"e3a1a42a-32d4-4a49-b14d-95a9635672c4",
				"1203c634-2827-4914-b426-fe308d393c72",
				"f06080ea-59d0-454d-b96f-74db89168177",
				"19a92141-c217-46ba-948a-5910a5763137",
				"e125027f-afb7-4816-ac1c-c862945f8ee7",
				"72cfbf70-29b1-492d-89e6-cae62f28dece",
				"c0b42f23-e456-426a-a971-28f179865c7e",
				"83f54399-48a0-4c3b-9550-0e4781bb10ab",
				"55ab05dc-7d19-42c1-bd78-ffc5e5a18fb5",
				"6e1c2d8c-c336-4f3e-85dc-7f6e003fc276",
				"589a246d-797b-4ff0-b27a-7fdef1f12266",
				"d19323f8-610e-4e3a-8fcf-32e5587b51c7",
				"2a44d35a-9c92-4523-b16b-16e64aa0191e",
				"1373a40b-498b-4c2e-83bc-24f31f6f4be1",
				"2b36a1c2-28ff-402b-a68a-110ce5f76578",
				"52b2bfb7-8b82-431a-b782-9e42dcf843d4",
				"4f2a6260-daaa-4f1f-90fa-5cf6a8a41eb0",
				"70e6ef9c-8d4b-422e-b218-7d4a63c019a9",
				"3fbe6658-3e24-4c99-97ef-dc78ee06d780",
				"fbae7274-b11a-4073-a1c2-b765be55a35a",
				"72e10aac-01ac-4f7e-92f4-169236c65000",
				"7d5efdc5-7ce5-4ebb-a75c-1df7b1d2723e",
				"c9c340fe-2fb5-49e9-bd48-23a4cbea4e6f",
				"8fcbc1fb-8172-4b81-ad7b-4850ced8935b",
				"485b2a0e-89e7-4193-900f-d1a1012bec82",
				"e8415682-e01a-471b-a7aa-80dad30d06d9",
				"68e2ab00-106e-4a47-b585-79243e9be4d2",
				"640411dc-5de6-422f-9bf1-5d6483d67c50",
				"b82034f2-8d08-476e-a896-6a9dcb20969a",
				"0d47c60d-34b1-4653-96fe-e1abd244a543",
				"365e772a-949c-4e35-b67a-d6813b9b4429",
				"c37ff23e-fe5a-40bf-9ec7-f08cf61d8be8",
				"590bc9c4-70b4-4a51-9a6b-0beef4f874f8",
				"a0adee10-418b-4d9b-bd4e-361155bfae25",
				"06665166-d9be-4396-8818-2aa2c0fbd68b",
				"0e17553e-a74e-41f6-8f29-7f3c81f955ec",
				"198f5fa7-4fc0-4260-b064-924fba34fffd",
				"15929992-132c-4af9-8ac4-569a0a3bfe93",
				"d5961047-033f-45dc-a742-92f1c155dc4d",
				"7b0a1f1b-4e60-49fd-9e78-c1c96105474c",
				"5a9087d8-94a3-4a8f-bcbe-585c339eb4f6",
				"ba47ea8e-1a90-48a8-af86-2cc29f26ff05",
				"89213840-07ef-468f-9b0e-4394aad7ee5b",
				"b736ea30-ed1e-408f-af90-5e9a9b179b73",
				"d0629d6a-24ca-4aa4-8118-2d1c2875272a",
				"a478e6f4-f1a6-4d1d-9386-d81ed825f9d2",
				"eb9308c1-642f-4473-b805-1ca17b9103bf",
				"fc2c3533-d089-470a-bb23-1b6cc1ec086d",
				"33d16604-a004-4415-8cf4-dc30c0fe7509",
				"ce76612e-ef9c-46fe-8fee-7731d44001f2",
				"2e338623-1dbf-4287-bba1-8840145658f4",
				"ab36c114-9f95-4abf-ac5f-dff950ca97b0",
				"d81b1dbe-5171-4268-9883-1feb498489b4",
				"69bfd80b-4d98-4d5f-8329-c50e9fb7f9bb",
				"22211ae8-ff2f-4900-968e-afb941786d25",
				"c41ed3d6-704e-4170-b9d1-24539918ed54",
				"7bd49bd4-9d41-4462-94a4-0d2863c829d9",
				"9a80c38f-56ec-44d0-bf77-09e812fd9ba3",
				"a95e6b26-2c6b-4305-b882-7571c7224a2b",
				"bd29da27-f4d5-4f83-bdb4-95907d57a692",
				"83cfec5b-d752-4ae7-9d25-97df99c1636f",
				"5b3f990a-0c29-48c9-8be3-7b70159c335f",
				"2164216b-58b1-4061-9e1c-73fb7e9f0e00",
				"693a0267-9a29-4de1-aaf1-4f0b7314a330",
				"8e3f6f17-09c7-46a3-912e-474f9a6438ee",
				"7e646642-b1e9-479d-a8a5-de936268e51b",
				"0795bdb2-db57-44a6-be16-9eddc74de687",
				"3d4caf80-a58c-460f-8748-6ba351decfe1",
				"2229a919-0731-4a7c-ae53-44da39f58f76",
				"2192aec2-2be7-4b53-8539-002da144b0be",
				"91b8836e-910a-4202-a671-5191658c3c6f",
				"d99eedef-af7f-47c7-98f1-542431006a77",
				"6a6cf3ab-8918-4869-b829-c4fed80c9c63",
				"2e018734-1203-42c1-b7d4-c044f46f9a23",
				"99e6dcfd-9570-4775-bca4-566213bc5930",
				"867159db-0242-42d7-a7bb-3c8f6a94107a",
				"63115f1d-d7d9-47a2-9a61-77da52492bd9",
				"767cc406-9dd9-48a8-9d1b-37d49db38048",
				"aa386ac4-aa45-4a1e-8080-e89cf3c94a75",
				"99926722-2bd3-45c5-8248-0ddebbc4a781",
				"95c4c98e-8282-499a-8384-af1b747516d0",
				"2b703737-1d61-4014-ba51-e1717ae3bf84",
				"b7b364f9-2afe-4514-9baf-3a6ac7ee199c",
				"87c0dd4e-d623-4a32-bf4b-af44bc880873",
				"e3f41409-78be-4ffd-81a1-1ce88cb82149",
				"25a3c4d4-8ed6-445c-8a37-327959326654",
				"367acd50-8ba8-4927-aed6-f47efe3a0758",
				"1a73d788-ae3a-4d96-a0bd-d8c400642815",
				"08587d4c-6969-4a23-8703-27f18166386d",
				"26b577fc-a430-4bf2-87cb-8c23624c82b4",
				"6921bed0-20e4-483f-a94c-88fed7c9f3b3",
				"65c88c7b-f9c6-4d61-ab87-c3adfb190ea0",
				"ee5f046f-bf9c-46ed-8b21-54dd5c8faed8",
				"9bf18ef3-5485-447b-860d-80aa00028051",
				"fbb0a142-c9e3-4d45-9693-fd33c4e5faa7",
				"798988ed-10ff-4277-b77d-a0ec50f0cac3",
				"0aee1653-878d-4179-93de-b02de477a4ad",
				"82d4a397-891f-41da-8789-a6d2ccc72066",
				"72cec629-bc0b-4028-96d6-9a3fa9c9ce8a",
				"9d1ac02d-0a22-49fa-a7d2-7f31dee5d3db",
				"24429c10-0780-47ef-a48b-4003d684125a",
				"80b8d76f-330e-4c8b-9daa-88cc956cf34c",
				"0b28bf06-4022-49ad-8aed-c46fc98ea94c",
				"4b1fab60-a2cf-4668-a8ca-5af98f17bf74",
				"17c15744-9d7e-4cb3-b197-1fec9dfc2d0b",
				"0588d1c7-0fa5-4879-8ed2-cd25b4702b4c",
				"63144ddc-a46a-4649-bbc1-39e5fdd7cf18",
				"67631b8d-011a-41cf-84ae-bd4de3c9222d",
				"c3e2d121-418e-4da6-a5df-7e80ae22de3c",
				"250343d6-b2c3-46d3-a847-29df56095400",
				"c72b3cf6-ff23-4acf-a78c-803e23681d62",
				"3aaa4782-f3fa-405b-ac69-11f16930cce1",
				"71977311-dc33-4b41-9f51-54fc005077bf",
				"ec7497fd-e5c7-4c14-9f35-2e5ab67ed67e",
				"b3530cf3-2944-4905-aa43-b08b560f7c34",
				"42b7e358-1861-442a-885c-65f21e87501f",
				"770c2979-86b0-49ec-8d2f-9336abe987a9",
				"9b5069be-cb97-46e5-9753-d81336a4e5a2",
				"c6769157-8a9e-49e4-aaea-b8c9150c3626",
				"d5236a0e-e6be-4b2e-9279-dd23524e20dc",
				"ca558d4d-8988-45cd-a80b-a71082ef300c",
				"4417056c-5ce5-4967-8ad3-835cb1ec9eec",
				"61ebfc7a-3235-48aa-b1c8-c47c9b4cc04b",
				"0e29b335-31f2-442e-ad17-13d0948e3913",
				"faedf7a6-2bc5-4998-8e7c-c41a2ccb3c17",
				"4cacf52f-9944-4144-bc50-84d0554cd2d0",
				"fdf13b95-9b68-4efb-88f8-390b5e7774fb",
				"1fe10717-caaa-4498-8b08-e0b4c7e5c025",
				"c1fec180-404b-4d19-a530-7a74b5acb6d9",
				"2da7dc83-ede5-4a77-9f55-c3fce7499e6f",
				"d2d44330-4b73-4acf-8ca5-a28b5dae4c92",
				"c8217d95-472c-4300-a93c-1aa84a2dc9aa",
				"dcf2fd61-bcb9-44df-8f90-c8de52fc7782",
				"574bc61e-6ffd-4108-a490-30c624a3f03f"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "59965235-a5bf-47ab-a373-a550ce0256e7",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/clean\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "932973be-4901-40be-a9f4-ce7e3642e0fd",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7864cd6-2e21-495a-9b51-ae4ed7f1f1fd",
			"type": "header",
			"properties": {
				"title": [
					[
						"Знаки"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d7e9841d-e443-46e2-aa0e-9402858b354f",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Дефис «-»"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f93f6a4-3fec-4750-8245-970686bf8f86",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем в составных конструкциях. Запомнить формулу легко:\nслово + слово, слово + число, число + число (если такая пара — не диапазон). "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "03a33099-5dce-4628-a0a5-ca3b9dc3abad",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "65dc1f35-7097-4432-ad3b-a1c05eb413cc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3fef077-54fe-4d08-af50-568d719ca68c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не отделяем пробелами"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "de071e38-da5b-47d4-8e7f-7692da6564f3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8ce4e5bd-65a9-4fa3-b0d3-00eff3d811d1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не разносим на разные строчки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cddf1d27-a44d-4eb8-82f8-cdc2b6911def",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9347113-ed15-46f5-9cd0-d52a24a79929",
			"type": "text",
			"properties": {
				"title": [
					[
						"(отдельная клавиша на macOS и Windows)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "50d8f978-209a-4155-95de-544ab1237d09",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1ff6cd3c-4b8a-43dd-9d17-1693afc49b74",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f04e9236-1a67-4a9e-8819-a8e4792e9fc6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "97879833-bc33-4b6e-8c5a-6fe6595c6186",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"слова: супер, мега и т. п. — используются без дефиса "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b54d44a4-e243-47bc-8deb-b32f477e0aad",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "79dfd380-cd00-48e4-a168-92c5e76075ed",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5b6b39a5-bac0-48d5-ae04-41b09cdd3408/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 720,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5b6b39a5-bac0-48d5-ae04-41b09cdd3408/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"5b6b39a5-bac0-48d5-ae04-41b09cdd3408"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/79dfd380-cd00-48e4-a168-92c5e76075ed.png"
		},
		{
			"id": "bb6c534d-7478-43d9-95fe-21ad6617e3e5",
			"type": "callout",
			"properties": {
				"title": [
					[
						"во-первых, код-пароль, онлайн-перевод\n\n450-45-45 (для телефонов)"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "55bf5813-be18-4fc5-9f21-75be362b1071",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65b828a2-444b-4c12-a9ed-3e6fcf35e67d",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Короткое тире «–»"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72dbb176-2061-45e5-a285-ab07dc3a0b34",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем, чтобы обозначить диапазон чисел или дат. "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d8ab1bfa-fbcd-4825-ba77-43e3a7d9c299",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69898a5f-09e5-4896-b3c4-93d31b5f201e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не отделяем пробелами"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d90a312b-b5ad-49e4-a783-ed13c2217163",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc91a676-d576-4f21-a357-4e6d233a8fbf",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"при переносе не разносим на разные строчки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b6228075-6869-4097-99cc-bb988805e01c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e46e86f7-a33e-4fca-bfc3-0b05acab0a2c",
			"type": "text",
			"properties": {
				"title": [
					[
						"(сочетание клавиш на macOS: Option+ –, на Windows: Alt + 0150)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b5964d17-af7c-4a4f-a978-a68845fdf2e1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c242c9d8-02ce-4ae6-bd7e-51916efd3236",
			"type": "column_list",
			"content": [
				"54a016d6-b1bf-4f4f-8ae3-81d5cf8e46aa",
				"f6779b5f-3eee-438b-ad13-68d393c077b7"
			],
			"format": {
				"block_width": 720,
				"block_full_width": false,
				"block_page_width": true,
				"copied_from_pointer": {
					"id": "a72cf6d2-847b-4e11-bb01-97afde4f0efb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "336ba265-3427-4de7-93b4-958d942905fb",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Длинное тире «—»",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4da46509-d00b-41e0-9f76-d74f9f8c9779",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем в повествовании в предложениях. "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5729a417-7752-44c8-a863-9718b6206f2c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cfe42ae5-a78a-4905-bc5c-2ba752b0cd92",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"с двух сторон отделяем пробелами"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "549cae97-fb21-4ee1-a8f6-c0c2af40ace2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fd60ce87-d028-4055-a11e-10cf83463ae1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"при переносе фразы оставляем в конце строки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9b1d9908-eae0-4e52-9074-2756fb25a4f8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "60ba7901-50ef-4813-a599-8ecb40cae7fb",
			"type": "text",
			"properties": {
				"title": [
					[
						"(сочетание клавиш на macOS: Option+ Shift+ –, на Windows: Alt + 0151)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "16616356-f1cf-4473-99f9-bee1a4bd3311",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5f972338-11af-4890-9175-893cfc5f6d22",
			"type": "column_list",
			"content": [
				"21ed401f-be80-4219-839a-4e3f4a0211a6",
				"05789351-ccb6-475f-86b6-428a37b12fb1"
			],
			"format": {
				"copied_from_pointer": {
					"id": "79c92c36-e8dd-407f-85cd-e51e22e77e5f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "84e84070-0c46-4c0c-91ae-e48f6facd637",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Процент «%»",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f4bc694b-2967-4c38-86eb-4b51040032c7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Стараемся использовать исключительно символ «%», не слово прописью. "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5bd5d568-6210-42bb-a6fe-299662ecdcdc",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2dde4c94-30ae-4e26-b5ec-663c564b9508",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d7ce3ea4-e486-4f6f-bd0f-15045e914560",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"от числа — не отделяем пробелом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5c36b2c5-24c9-4896-9045-e6be3a12aba0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72305868-915b-40f9-af46-c2b1a09b74b1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"используем «процент» прописью, если стоит с другим словом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6f95ac18-5493-4d10-9ab1-bb4962cfde01",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2fe07a5a-dea5-4c5c-bd4f-9cf8dfa2fcdb",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"при переносе символ «%» не отделим от числа "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e7b9d0df-b814-4ead-8c60-b2413669db09",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "201a2496-d2f3-4a51-a5f8-1f068b070aef",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"слово «процент» не сокращаем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7f3b4911-b88f-426f-b368-28186ade5e9f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fd526106-ee6f-49de-a869-aa3987e2c4d6",
			"type": "column_list",
			"content": [
				"303d778b-f02a-4f99-a510-86cd23500aad",
				"934a60c2-379c-4e65-bc75-7a42aff503d1"
			],
			"format": {
				"copied_from_pointer": {
					"id": "13cd1705-4b9c-4b74-bef0-db49b8901899",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d4a32e28-a992-4d3f-9252-7031a22aad80",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Слеш «/»"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "97699c60-5380-467f-b7e4-4092482f5104",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f67722c4-d5ee-411f-ad82-3b1451af7345",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fcb4c0b6-e902-4e2c-bb77-de5501c37a5b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не отделяем пробелом от числа или слова"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b78143b5-f6d9-4a9a-990e-ede10eb4aa2c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b2e127e0-3eee-4b98-be4d-760ac17c98ef",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не переносим на новую строку"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4f92f6b6-2668-4bd9-a3e6-ac0793994878",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce7e9edd-23a4-4efb-b46f-ebb21021e194",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не используем «/», когда он обозначает союзы «и», «или» — находим другую формулировку"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8e660298-c82a-4dca-9fc6-b6f16607ba2a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "600c1638-d6b0-4442-8305-e3c0162640b1",
			"type": "column_list",
			"content": [
				"0eeb3e71-37c9-40df-88b4-95d494164890",
				"bd204087-31ff-4838-b8fe-810eef28c093"
			],
			"format": {
				"copied_from_pointer": {
					"id": "928dc439-6e8a-4d43-9345-9d0bf8e8f5cb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "06178e39-bc91-4360-9718-d076baa1e364",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Кавычки «» и „“ "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bf82f73e-1366-4c0b-8ca8-b263cb901667",
			"type": "text",
			"properties": {
				"title": [
					[
						"Кавычки-ёлочки — общепринятые кавычки в русском языке. \nКавычки-лапки используем, если они внутри фразы в кавычках-ёлочках — то есть цитата внутри цитаты. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1bc0e703-9af7-4083-88f8-d360f2048206",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36fdc020-b5af-4264-9586-f4961df1e1f9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c44bf0e3-52d9-4ae9-b805-2026f9ea60fb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9c02599b-abb3-4aaf-86e0-29ea44ad1d44",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"точка ставится за пределами кавычек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1f83dfe2-5b97-4f16-926d-3dca930c27ee",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a580c6f5-c985-42a4-9e1f-f06b21f4b19c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"«!» и «?» — в пределах кавычек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "142d8953-f095-42b2-989a-85a0e5c003b7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6acba627-0f84-4489-8fac-6583370b7a25",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Иностранные названия на латинице — без кавычек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "610e4a47-a1bc-437d-b7bc-e43fb155d19c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "faa5eced-f21b-440f-856f-fe05315dab5b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Иностранные названия на кириллице — в кавычках-ёлочках"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "95f81430-f5f8-484c-b1da-c9e732c2acf0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d08496d1-e38e-42f4-913f-0281d63418d1",
			"type": "column_list",
			"content": [
				"9af78413-7cf3-40cb-9af3-86d0044e05bc",
				"673c3641-ad7b-4d3b-894f-b838a3ce7edb"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9510969d-0e51-45d3-ae56-be4cb7ba7bdc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c04e4823-161d-4a36-95fb-73cfbd342d57",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Двоеточие «:»"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f11d7112-24c3-4317-ac25-b44501cdcd6b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем для перечисления условий, принципов, шагов и т. д. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b3b3b102-9b6b-4508-9811-c793a84274d1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3a315020-4d58-476b-bacb-bdf18f9eafa5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c3c85952-53a8-4ac5-9ee3-2b2cd4a06a16",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6ee5d949-c739-4f2f-a6a1-e44fcd1e0a35",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"перед «:» — пробела нет"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bab54241-ef54-4271-a668-1c22ad64b9a5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f204f905-a50d-4e58-826d-b92f5287368f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"после «:» — пробел есть"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "693503d4-4618-4c45-aac6-971f7c4b3731",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e5cc036e-ded8-4ab5-9e5f-96f051baa10c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не переносим на новую строку"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dcd8f691-1838-40cb-9976-bfba9cc381ef",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9c97b9fb-099e-40cc-b72e-c4a5281c1095",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a6edb09e-3ad2-410b-a52c-1d32f7e4c185/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a6edb09e-3ad2-410b-a52c-1d32f7e4c185/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"a6edb09e-3ad2-410b-a52c-1d32f7e4c185"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9c97b9fb-099e-40cc-b72e-c4a5281c1095.png"
		},
		{
			"id": "a4c78281-b97b-4895-ae64-85d23d819db0",
			"type": "callout",
			"properties": {
				"title": [
					[
						"тарифы: первый, второй, третий"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "856af833-ed3b-4ae0-81c0-acbacca97dcb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b203b4be-228f-4b22-973a-ef6b96350f73",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Скобки ()"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "52714aba-71f2-4664-8ac1-e7a0e78d782e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3b047bbb-a4b9-42b9-a028-857492f28303",
			"type": "text",
			"properties": {
				"title": [
					[
						"Скобки перегружают текст: визуально — шумят, по смыслу — как будто мы что-то \nне договариваем. Поэтому, если от них можно избавиться, делаем это. \nВ 99% случаев скобки останутся в юридических документах. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aae80ca3-5908-4eda-8ff4-c57acc88d513",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "64b4e3a9-12a0-4701-a531-9ebbf7b4796e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "788cf9b1-b785-4890-b562-c17da92e34b9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "21afbd22-0224-4a01-a6e1-fc485ca5cb38",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"ставим пробел перед открывающей скобкой и после закрывающей"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4b70dbae-7496-4765-b899-0219e5e72e6c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cfe08ee8-6d71-489a-956a-6f90ab270a7a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"пробелы внутри скобок ставим только между словами — между скобкой и словом они не нужны"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "36b065c9-d9d1-4d2b-a868-d6577f939d78",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8b4af153-2cce-4ece-bd13-9a37266c638b",
			"type": "column_list",
			"content": [
				"b290b219-6955-40bd-9858-8b73d3297c95",
				"0ccc0742-b595-4a11-bbb5-b22e4604e2d8"
			],
			"format": {
				"copied_from_pointer": {
					"id": "4d4d0ec1-9593-4397-a13d-e57123b7dcbc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "884632f9-6153-41f8-bf9c-1d2b8250d543",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Номер «№»"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0078dc42-c999-4b5b-9e12-737aaa5701a7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c55dac27-cfad-4ad2-8984-09733b23f351",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3f12ecfa-9ba5-4d1f-ae7d-0f6f1708a26a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "908edd23-6be6-456b-98a4-cb7742ca4020",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не отделяем пробелом от числа"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "90fec437-ab7f-4f58-a349-fb0815e2def1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f24c9c4b-055c-4f15-bdac-d2d85e2dc5f5",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не разносим на разные строки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d6bc9623-ced0-432b-a97d-21d433372cc4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc01368d-78f1-4394-b0ec-89f6e4f8b601",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не используем знак «#» для обозначения номера "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d7073ce3-ef8e-422f-b888-765a4eb6df35",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8b78f2a0-2e0e-4095-bbe1-0c11171217fa",
			"type": "column_list",
			"content": [
				"1dbfc3cd-be62-4bbd-8c5c-8c37483091b3",
				"6d39da92-d4b0-48f1-9e29-ab8c6a0cd989"
			],
			"format": {
				"copied_from_pointer": {
					"id": "edd586f7-9728-43f2-a3b5-50d9e332e94d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e3a1a42a-32d4-4a49-b14d-95a9635672c4",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Минус «-» и плюс «+»"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8e22ef8c-bad9-42c2-a99f-bc1a403caf6b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1203c634-2827-4914-b426-fe308d393c72",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "76922a87-5141-4fad-94de-365ea8c9f1dc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f06080ea-59d0-454d-b96f-74db89168177",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если «-» или «+» — знаки сложения или вычитания, отделяем пробелами от чисел "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eca69edc-1b6a-41d5-a19e-0cadd004781a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "19a92141-c217-46ba-948a-5910a5763137",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"в остальных случаях — не отделяем пробелами  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "991cf0d0-efc3-44cf-bdd3-b2599bee82c3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e125027f-afb7-4816-ac1c-c862945f8ee7",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не используем со словами"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1d96b932-8f8c-4f83-ad84-47b61c9677c4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72cfbf70-29b1-492d-89e6-cae62f28dece",
			"type": "column_list",
			"content": [
				"b27334cc-c605-49bc-b075-9a57dc43fb79",
				"65c170b1-e4b5-44e2-af89-96c998c0702b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9f7ea196-3db8-4d83-8d31-71e8aceee8d8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c0b42f23-e456-426a-a971-28f179865c7e",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Знаки валют: ₽, $, € и др."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1a55eae0-bc9c-4442-b134-9f4b988c581e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83f54399-48a0-4c3b-9550-0e4781bb10ab",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6a4b4b04-bcfc-4017-9a8b-5ae155998576",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "55ab05dc-7d19-42c1-bd78-ffc5e5a18fb5",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если знак валюты стоит перед числом — без пробела"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0a748ea9-9d01-48d3-9005-431cc5b63443",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e1c2d8c-c336-4f3e-85dc-7f6e003fc276",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если после числа или слова — с пробелом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d29b75aa-e83c-46bf-b7e4-20d8eb4842c7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "589a246d-797b-4ff0-b27a-7fdef1f12266",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"ставить знак валюты перед или после числа — определите в контексте формата "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "90c5e624-4595-40f7-b875-5e432eb75c9a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d19323f8-610e-4e3a-8fcf-32e5587b51c7",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4439da73-c3fd-43eb-bf8e-c4119f3308d1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4439da73-c3fd-43eb-bf8e-c4119f3308d1/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"4439da73-c3fd-43eb-bf8e-c4119f3308d1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d19323f8-610e-4e3a-8fcf-32e5587b51c7.png"
		},
		{
			"id": "2a44d35a-9c92-4523-b16b-16e64aa0191e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"$100 млн \n\n100 ₽\n\n500 млн ₽"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "dfdd5639-88af-4945-bba9-9ad62f8d4b15",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1373a40b-498b-4c2e-83bc-24f31f6f4be1",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Объём памяти: КБ, МБ, ГБ и др. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8bb92580-6bad-41ef-99ae-ba0f8a08bd65",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b36a1c2-28ff-402b-a68a-110ce5f76578",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4280aae6-342e-4885-b68d-b376d6c17a9a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52b2bfb7-8b82-431a-b782-9e42dcf843d4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"бит, байт — пишем по-русски, склоняем, не сокращаем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b6d21c35-f3ca-40b8-9d0e-7e7765f9bcad",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4f2a6260-daaa-4f1f-90fa-5cf6a8a41eb0",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"КБ, МБ, ГБ, ТБ — сокращаем до двух заглавных букв, точку в конце не ставим"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b2689118-e492-4189-9cc2-dc8b070234df",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "70e6ef9c-8d4b-422e-b218-7d4a63c019a9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Кбит, Мбит, Гбит — когда речь про скорость интернета"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b9e77b75-b23c-4a3e-aabe-41603ee34da8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3fbe6658-3e24-4c99-97ef-dc78ee06d780",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"в маркетинговых форматах допустимо писать слово полностью, например: \nне думайте о гигабайтах "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1520166c-65b5-445f-96a9-1ed3c3e09457",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fbae7274-b11a-4073-a1c2-b765be55a35a",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3a9ce428-a474-42b1-8ec4-830543ddc5ee/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3a9ce428-a474-42b1-8ec4-830543ddc5ee/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"3a9ce428-a474-42b1-8ec4-830543ddc5ee"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fbae7274-b11a-4073-a1c2-b765be55a35a.png"
		},
		{
			"id": "72e10aac-01ac-4f7e-92f4-169236c65000",
			"type": "callout",
			"properties": {
				"title": [
					[
						"128 ГБ в Облаке\n\nСкорость интернета — 100 Мбит в секунду"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "52395537-1f2f-4d3d-a980-bec4ae06bc60",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d5efdc5-7ce5-4ebb-a75c-1df7b1d2723e",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Сокращения: млн, млрд, тыс., руб."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0d2c7dac-9d43-4978-87f3-a7efe7a1d0af",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c9c340fe-2fb5-49e9-bd48-23a4cbea4e6f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "30e0de52-c392-4b2e-b2ae-57df87032e46",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8fcbc1fb-8172-4b81-ad7b-4850ced8935b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"отделяем пробелом от числа или слова"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5d5122f7-afdc-4beb-a9a6-49efb23aee05",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "485b2a0e-89e7-4193-900f-d1a1012bec82",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если слово прерывается в какой-то части — ставим точку: руб., тыс. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c5c4ef6e-3b48-4951-a319-b10567a2d5b6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e8415682-e01a-471b-a7aa-80dad30d06d9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если исключаем гласные и часть согласных — точку не ставим: млрд, трлн "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "de328097-71a0-4cb0-996d-08af6bcfef5d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "68e2ab00-106e-4a47-b585-79243e9be4d2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"используем знаки валют "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1b8a04e1-2436-43e0-b074-69f4ab705120",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "640411dc-5de6-422f-9bf1-5d6483d67c50",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ba5603c7-c25e-4a34-af36-e96fea21a034/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ba5603c7-c25e-4a34-af36-e96fea21a034/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"ba5603c7-c25e-4a34-af36-e96fea21a034"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/640411dc-5de6-422f-9bf1-5d6483d67c50.png"
		},
		{
			"id": "b82034f2-8d08-476e-a896-6a9dcb20969a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"500 ₽\n\n10 трлн пользователей \n\n812 $"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "59afbe86-8834-4591-b962-23afae471e6a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d47c60d-34b1-4653-96fe-e1abd244a543",
			"type": "header",
			"properties": {
				"title": [
					[
						"Слова"
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "365e772a-949c-4e35-b67a-d6813b9b4429",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Продуктовые и маркетинговые названия "
					]
				]
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c37ff23e-fe5a-40bf-9ec7-f08cf61d8be8",
			"type": "text",
			"properties": {
				"title": [
					[
						"В интерфейсных текстах важно сохранять чистоту и вместе с тем — давать однозначную информацию человеку. Переизбыток кавычек в коротких текстах создает шум — избегаем подобного. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "09c83601-67d4-4af2-a65c-0136a1e83674",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "54a016d6-b1bf-4f4f-8ae3-81d5cf8e46aa",
			"type": "column",
			"content": [
				"d118d44e-dc8c-4d62-84b3-cb6ffcfbb8f7",
				"7ece5fe9-f1ae-4358-9fb4-aa436908f491"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "686a4c4e-26e7-4d18-9b83-6bd9858cfe9f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c242c9d8-02ce-4ae6-bd7e-51916efd3236",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f6779b5f-3eee-438b-ad13-68d393c077b7",
			"type": "column",
			"content": [
				"590d2ba0-fcf3-4bd3-ba25-da647a085d42",
				"e212d973-9025-4444-a84d-0a2af0ed5b7e"
			],
			"format": {
				"column_ratio": 0.4999999999999998,
				"copied_from_pointer": {
					"id": "52a61881-7160-48ce-bd1f-3a0fb9468388",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c242c9d8-02ce-4ae6-bd7e-51916efd3236",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d118d44e-dc8c-4d62-84b3-cb6ffcfbb8f7",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5482d69a-d4b1-487c-a74e-fe67567802fc/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5482d69a-d4b1-487c-a74e-fe67567802fc/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "54a016d6-b1bf-4f4f-8ae3-81d5cf8e46aa",
			"parent_table": "block",
			"file_ids": [
				"5482d69a-d4b1-487c-a74e-fe67567802fc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d118d44e-dc8c-4d62-84b3-cb6ffcfbb8f7.png"
		},
		{
			"id": "7ece5fe9-f1ae-4358-9fb4-aa436908f491",
			"type": "callout",
			"properties": {
				"title": [
					[
						"когда: 5–25 марта, но: \n19 марта – 5 мая\n\nна страницах 100–118"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "825e334e-0cc9-4400-aacd-d7a8b814f524",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "54a016d6-b1bf-4f4f-8ae3-81d5cf8e46aa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "590d2ba0-fcf3-4bd3-ba25-da647a085d42",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f955e413-bd04-4197-a64b-4c0b677e77ca/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f955e413-bd04-4197-a64b-4c0b677e77ca/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "f6779b5f-3eee-438b-ad13-68d393c077b7",
			"parent_table": "block",
			"file_ids": [
				"f955e413-bd04-4197-a64b-4c0b677e77ca"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/590d2ba0-fcf3-4bd3-ba25-da647a085d42.png"
		},
		{
			"id": "e212d973-9025-4444-a84d-0a2af0ed5b7e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"оформление в течение 3 - 5 дней "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a7ddffbb-10a4-4223-ba7a-0f05c924036e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "f6779b5f-3eee-438b-ad13-68d393c077b7",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "21ed401f-be80-4219-839a-4e3f4a0211a6",
			"type": "column",
			"content": [
				"51c826f8-bd80-40c4-8e26-2d2c1ef22478",
				"b6f12538-3ec4-4d91-a06b-ae89e7bb3d39"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "6d623511-a861-480d-b3db-5bef3f616412",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5f972338-11af-4890-9175-893cfc5f6d22",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "05789351-ccb6-475f-86b6-428a37b12fb1",
			"type": "column",
			"content": [
				"3bc3498c-7e1c-4545-80bc-225be49ef26b",
				"00659b99-8ad0-4843-b05a-a780bcf478ca"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "a1bdbb1e-906d-4012-9955-450035523dd3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5f972338-11af-4890-9175-893cfc5f6d22",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "51c826f8-bd80-40c4-8e26-2d2c1ef22478",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a4066cfa-083f-442a-8dfa-6b00cd62119c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a4066cfa-083f-442a-8dfa-6b00cd62119c/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "21ed401f-be80-4219-839a-4e3f4a0211a6",
			"parent_table": "block",
			"file_ids": [
				"a4066cfa-083f-442a-8dfa-6b00cd62119c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/51c826f8-bd80-40c4-8e26-2d2c1ef22478.png"
		},
		{
			"id": "b6f12538-3ec4-4d91-a06b-ae89e7bb3d39",
			"type": "callout",
			"properties": {
				"title": [
					[
						"количество — \nне более 11 почтовых ящиков\n\nMail Space — больше места \nс подпиской "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "aedb9ae3-f5e8-4411-843b-b68cb019598c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "21ed401f-be80-4219-839a-4e3f4a0211a6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3bc3498c-7e1c-4545-80bc-225be49ef26b",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fc2395fb-3816-4a79-8470-94b418a29d52/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fc2395fb-3816-4a79-8470-94b418a29d52/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "05789351-ccb6-475f-86b6-428a37b12fb1",
			"parent_table": "block",
			"file_ids": [
				"fc2395fb-3816-4a79-8470-94b418a29d52"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3bc3498c-7e1c-4545-80bc-225be49ef26b.png"
		},
		{
			"id": "00659b99-8ad0-4843-b05a-a780bcf478ca",
			"type": "callout",
			"properties": {
				"title": [
					[
						"выбрать тариф—просто\n\nУдобно делиться \n — сразу с тремя близкими  "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "e7d6931b-2757-4cd8-a608-07363798a124",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "05789351-ccb6-475f-86b6-428a37b12fb1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "303d778b-f02a-4f99-a510-86cd23500aad",
			"type": "column",
			"content": [
				"5a153f67-5614-4b77-a501-781753598ea2",
				"78c56d69-8bb2-4660-a4a8-c540b3915e31"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "4e597d4c-dd88-4c38-ba83-87d4a80d27c5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fd526106-ee6f-49de-a869-aa3987e2c4d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "934a60c2-379c-4e65-bc75-7a42aff503d1",
			"type": "column",
			"content": [
				"d1f1c04f-a2dd-4e75-a496-28da11d7443f",
				"17657700-ffa7-4bdf-ba0f-249d2c9fbdea"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "ed9f244b-48ec-41a0-9947-c05df8d8cd2d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fd526106-ee6f-49de-a869-aa3987e2c4d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5a153f67-5614-4b77-a501-781753598ea2",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ab7c98a-a216-4349-91d9-a1a7457eca79/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ab7c98a-a216-4349-91d9-a1a7457eca79/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "303d778b-f02a-4f99-a510-86cd23500aad",
			"parent_table": "block",
			"file_ids": [
				"2ab7c98a-a216-4349-91d9-a1a7457eca79"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5a153f67-5614-4b77-a501-781753598ea2.png"
		},
		{
			"id": "78c56d69-8bb2-4660-a4a8-c540b3915e31",
			"type": "callout",
			"properties": {
				"title": [
					[
						"100%\n\nОдин процент \n\nпроцент на остаток "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1058f816-57bf-450a-88b3-5d629fb9312d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "303d778b-f02a-4f99-a510-86cd23500aad",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1f1c04f-a2dd-4e75-a496-28da11d7443f",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/17be63a8-3a68-47ae-a26e-38a404e0e476/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/17be63a8-3a68-47ae-a26e-38a404e0e476/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "934a60c2-379c-4e65-bc75-7a42aff503d1",
			"parent_table": "block",
			"file_ids": [
				"17be63a8-3a68-47ae-a26e-38a404e0e476"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d1f1c04f-a2dd-4e75-a496-28da11d7443f.png"
		},
		{
			"id": "17657700-ffa7-4bdf-ba0f-249d2c9fbdea",
			"type": "callout",
			"properties": {
				"title": [
					[
						"25 %\n\n100 проц."
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8e36ab2e-d992-4bd0-9341-4eb81d24b5c1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "934a60c2-379c-4e65-bc75-7a42aff503d1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0eeb3e71-37c9-40df-88b4-95d494164890",
			"type": "column",
			"content": [
				"2c6ffc21-e66f-4052-b83e-c184c2dbcb74",
				"05971b00-6d84-4667-88e3-799509dd298e"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e6a0024b-09ef-43fc-895c-181aa70530da",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "600c1638-d6b0-4442-8305-e3c0162640b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd204087-31ff-4838-b8fe-810eef28c093",
			"type": "column",
			"content": [
				"8db21e52-6ce8-4d86-a29e-1b1f5c82a2e1",
				"3f93a3b0-7020-4450-81db-7d7051409066"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "8abc5523-b11c-4977-b371-ed6c86d03436",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "600c1638-d6b0-4442-8305-e3c0162640b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2c6ffc21-e66f-4052-b83e-c184c2dbcb74",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3d5375d2-2db3-4857-bccc-8d8289e76acb/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3d5375d2-2db3-4857-bccc-8d8289e76acb/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "0eeb3e71-37c9-40df-88b4-95d494164890",
			"parent_table": "block",
			"file_ids": [
				"3d5375d2-2db3-4857-bccc-8d8289e76acb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2c6ffc21-e66f-4052-b83e-c184c2dbcb74.png"
		},
		{
			"id": "05971b00-6d84-4667-88e3-799509dd298e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"10/10\n\nПочта/Облако/Календарь\n(в юр. документах)"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ec11de59-db44-4f0e-a6a3-369207e5208e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0eeb3e71-37c9-40df-88b4-95d494164890",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8db21e52-6ce8-4d86-a29e-1b1f5c82a2e1",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3ff50ae6-8df2-405d-985d-de6fe609c2a0/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3ff50ae6-8df2-405d-985d-de6fe609c2a0/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "bd204087-31ff-4838-b8fe-810eef28c093",
			"parent_table": "block",
			"file_ids": [
				"3ff50ae6-8df2-405d-985d-de6fe609c2a0"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8db21e52-6ce8-4d86-a29e-1b1f5c82a2e1.png"
		},
		{
			"id": "3f93a3b0-7020-4450-81db-7d7051409066",
			"type": "callout",
			"properties": {
				"title": [
					[
						" Пароль и/или логин"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f94bb89b-bcb8-4bf3-8572-5bbfb0658017",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bd204087-31ff-4838-b8fe-810eef28c093",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9af78413-7cf3-40cb-9af3-86d0044e05bc",
			"type": "column",
			"content": [
				"52c208ed-1a59-4e5f-8885-113664c57e23",
				"f6bce50f-4259-41b5-b0eb-7e33d489ea10"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "ddf4cea5-076e-4a9a-b160-79c918e16b54",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d08496d1-e38e-42f4-913f-0281d63418d1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "673c3641-ad7b-4d3b-894f-b838a3ce7edb",
			"type": "column",
			"content": [
				"fcb01bba-1357-47cc-82fd-f0fd755974f5",
				"c8b3dbb4-ddd9-444c-9bc7-1cd372c49cab"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "c034c489-03e5-4b17-a1b3-622dc3449068",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d08496d1-e38e-42f4-913f-0281d63418d1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52c208ed-1a59-4e5f-8885-113664c57e23",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/183eab6a-d73f-4823-a1bf-9b0a4734f02a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/183eab6a-d73f-4823-a1bf-9b0a4734f02a/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "9af78413-7cf3-40cb-9af3-86d0044e05bc",
			"parent_table": "block",
			"file_ids": [
				"183eab6a-d73f-4823-a1bf-9b0a4734f02a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/52c208ed-1a59-4e5f-8885-113664c57e23.png"
		},
		{
			"id": "f6bce50f-4259-41b5-b0eb-7e33d489ea10",
			"type": "callout",
			"properties": {
				"title": [
					[
						"«ёлочки, а „лапки” внутри ёлочек»\n\n«да!»\n\nGmail\n\n«Эппл» "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5c06f933-531e-48ff-9ece-754b1ae2fc4f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9af78413-7cf3-40cb-9af3-86d0044e05bc",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fcb01bba-1357-47cc-82fd-f0fd755974f5",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ea72dcb-6d9a-4bee-8630-f13a4dfb9cf6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2ea72dcb-6d9a-4bee-8630-f13a4dfb9cf6/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "673c3641-ad7b-4d3b-894f-b838a3ce7edb",
			"parent_table": "block",
			"file_ids": [
				"2ea72dcb-6d9a-4bee-8630-f13a4dfb9cf6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fcb01bba-1357-47cc-82fd-f0fd755974f5.png"
		},
		{
			"id": "c8b3dbb4-ddd9-444c-9bc7-1cd372c49cab",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нажмите на кнопку „Да” \n\n«нет»!\n\n«Gmail»\n\n„Эппл”"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "78200f34-a0d6-4ba5-9dac-bff026e28487",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "673c3641-ad7b-4d3b-894f-b838a3ce7edb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b290b219-6955-40bd-9858-8b73d3297c95",
			"type": "column",
			"content": [
				"49927462-e25b-487d-9fb2-8a94c20efdb4",
				"bff67962-2eb9-4a08-abdb-75fabe7dd56d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "58da7c45-cb56-4213-a49c-fb8ab37fd025",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8b4af153-2cce-4ece-bd13-9a37266c638b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ccc0742-b595-4a11-bbb5-b22e4604e2d8",
			"type": "column",
			"content": [
				"6e62307e-c442-47f4-a5ec-cc1d47b3f65a",
				"f766b9fe-4231-46ff-8fc3-2c7d848e3a07"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "e04d7cf5-0b4b-4e7c-8120-1c99847ea8d4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8b4af153-2cce-4ece-bd13-9a37266c638b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "49927462-e25b-487d-9fb2-8a94c20efdb4",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d060bf97-31ea-4e2f-84b2-eaaf68c26985/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d060bf97-31ea-4e2f-84b2-eaaf68c26985/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "b290b219-6955-40bd-9858-8b73d3297c95",
			"parent_table": "block",
			"file_ids": [
				"d060bf97-31ea-4e2f-84b2-eaaf68c26985"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/49927462-e25b-487d-9fb2-8a94c20efdb4.png"
		},
		{
			"id": "bff67962-2eb9-4a08-abdb-75fabe7dd56d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"пользователь указывает адрес (фактический) "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b3f3cc66-8423-4a71-9ce6-50795010d8b4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b290b219-6955-40bd-9858-8b73d3297c95",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e62307e-c442-47f4-a5ec-cc1d47b3f65a",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9a06b829-9bbd-4387-b7b7-6225ee09f4fe/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9a06b829-9bbd-4387-b7b7-6225ee09f4fe/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "0ccc0742-b595-4a11-bbb5-b22e4604e2d8",
			"parent_table": "block",
			"file_ids": [
				"9a06b829-9bbd-4387-b7b7-6225ee09f4fe"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6e62307e-c442-47f4-a5ec-cc1d47b3f65a.png"
		},
		{
			"id": "f766b9fe-4231-46ff-8fc3-2c7d848e3a07",
			"type": "callout",
			"properties": {
				"title": [
					[
						"( условия в скобках )"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ee819ede-f703-42fb-9ab9-8b94fec62c9f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0ccc0742-b595-4a11-bbb5-b22e4604e2d8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1dbfc3cd-be62-4bbd-8c5c-8c37483091b3",
			"type": "column",
			"content": [
				"852b828a-c919-4bb6-8584-5e54e811c81c",
				"89f6cb7b-fc87-4530-8bdb-70a8f5ede21b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "fe3c088a-02a2-4bcd-ad30-e60e5e5900d5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8b78f2a0-2e0e-4095-bbe1-0c11171217fa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6d39da92-d4b0-48f1-9e29-ab8c6a0cd989",
			"type": "column",
			"content": [
				"a22606ee-6ccc-46bd-ac2a-142281902510",
				"c5e57600-0152-4a72-9395-1645be37696c"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "00333c2d-e324-472f-97c2-1b1ba0f1c162",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8b78f2a0-2e0e-4095-bbe1-0c11171217fa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "852b828a-c919-4bb6-8584-5e54e811c81c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ffb2480f-bd13-443a-a0e9-e7efa6c1b765/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ffb2480f-bd13-443a-a0e9-e7efa6c1b765/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "1dbfc3cd-be62-4bbd-8c5c-8c37483091b3",
			"parent_table": "block",
			"file_ids": [
				"ffb2480f-bd13-443a-a0e9-e7efa6c1b765"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/852b828a-c919-4bb6-8584-5e54e811c81c.png"
		},
		{
			"id": "89f6cb7b-fc87-4530-8bdb-70a8f5ede21b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"№6"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "acc7c4bf-373d-40b7-8cd6-becd0379447f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1dbfc3cd-be62-4bbd-8c5c-8c37483091b3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a22606ee-6ccc-46bd-ac2a-142281902510",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/68efb7e1-da88-4f2b-be6d-08edb1f7ce2f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/68efb7e1-da88-4f2b-be6d-08edb1f7ce2f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6d39da92-d4b0-48f1-9e29-ab8c6a0cd989",
			"parent_table": "block",
			"file_ids": [
				"68efb7e1-da88-4f2b-be6d-08edb1f7ce2f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a22606ee-6ccc-46bd-ac2a-142281902510.png"
		},
		{
			"id": "c5e57600-0152-4a72-9395-1645be37696c",
			"type": "callout",
			"properties": {
				"title": [
					[
						"№ 126\n\n#126"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "011edb0a-d10c-4b57-9640-669f7e58408d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6d39da92-d4b0-48f1-9e29-ab8c6a0cd989",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b27334cc-c605-49bc-b075-9a57dc43fb79",
			"type": "column",
			"content": [
				"4df40b66-578d-4a7f-a621-378c6e602df9",
				"ab8a49e9-810a-4c8f-b389-9e29d9b9ebb7"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "870d4f02-db36-4b99-8fec-27c6bfd5f5a4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "72cfbf70-29b1-492d-89e6-cae62f28dece",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65c170b1-e4b5-44e2-af89-96c998c0702b",
			"type": "column",
			"content": [
				"dfebc701-946a-4474-b0eb-0a88695313c1",
				"2661673c-6ed1-490c-93d1-f6cc2a05353f"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "56d46a7a-744f-4658-a150-6694dabf64b3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "72cfbf70-29b1-492d-89e6-cae62f28dece",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4df40b66-578d-4a7f-a621-378c6e602df9",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e232aa78-6a9c-4a4d-9183-27fd3ed15a00/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e232aa78-6a9c-4a4d-9183-27fd3ed15a00/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "b27334cc-c605-49bc-b075-9a57dc43fb79",
			"parent_table": "block",
			"file_ids": [
				"e232aa78-6a9c-4a4d-9183-27fd3ed15a00"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4df40b66-578d-4a7f-a621-378c6e602df9.png"
		},
		{
			"id": "ab8a49e9-810a-4c8f-b389-9e29d9b9ebb7",
			"type": "callout",
			"properties": {
				"title": [
					[
						"возраст 12+\n\n+10% к объёму памяти \n\nтариф: 1 + 5"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "38ed792b-1f9e-47ee-add5-13c65211a221",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b27334cc-c605-49bc-b075-9a57dc43fb79",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dfebc701-946a-4474-b0eb-0a88695313c1",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3b064d50-1dee-4559-81ca-0fdbb316bf9b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3b064d50-1dee-4559-81ca-0fdbb316bf9b/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "65c170b1-e4b5-44e2-af89-96c998c0702b",
			"parent_table": "block",
			"file_ids": [
				"3b064d50-1dee-4559-81ca-0fdbb316bf9b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/dfebc701-946a-4474-b0eb-0a88695313c1.png"
		},
		{
			"id": "2661673c-6ed1-490c-93d1-f6cc2a05353f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"десять - шесть = 4\n\nшесть +"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a5606aa9-5413-43e0-bad6-9645613c9253",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "65c170b1-e4b5-44e2-af89-96c998c0702b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "590bc9c4-70b4-4a51-9a6b-0beef4f874f8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7be2b9de-0f8a-47cd-b0ed-3af41567a91e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0adee10-418b-4d9b-bd4e-361155bfae25",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"названия продуктов, тарифов, баллов, шансов и т. д. — без кавычек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "77141385-f3ff-40ec-a872-4767815cc2e7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "06665166-d9be-4396-8818-2aa2c0fbd68b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если нужно выделить слово или фразу, например, название раздела — используем bold-начертание шрифта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "23656dea-02ab-43fa-961e-48f3cb4fe1cc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0e17553e-a74e-41f6-8f29-7f3c81f955ec",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"названия на латинице — без кавычек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "38702bcd-4754-4f3f-b7ec-0d0503a3131c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "198f5fa7-4fc0-4260-b064-924fba34fffd",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"любое название — с большой буквы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7501bbe2-5ae5-48ef-a15e-35903d45947b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "15929992-132c-4af9-8ac4-569a0a3bfe93",
			"type": "column_list",
			"content": [
				"da6ce7b2-c4f4-4d53-b4f3-17b5516e5e4a",
				"b86822b0-3060-47a1-80fc-09c06ba9661f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9dcd20a8-69f7-45f5-8daf-04ec348ad9ca",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d5961047-033f-45dc-a742-92f1c155dc4d",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Адреса"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8952b2ff-0dbf-4378-97d0-c23e7d240fc6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7b0a1f1b-4e60-49fd-9e78-c1c96105474c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d1c7e3d4-8f9a-4611-b0c3-eb189d0cd178",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5a9087d8-94a3-4a8f-bcbe-585c339eb4f6",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"используем общепринятые сокращения с точкой в конце: кв., д., корп. или к., ул."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0872ddf9-ff3b-4b19-a8e2-d54160fdde3c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba47ea8e-1a90-48a8-af86-2cc29f26ff05",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"сокращение отделяем пробелом от числа или названия"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "06b87f5a-2ee8-402a-b7dd-3f4ebb0cf676",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "89213840-07ef-468f-9b0e-4394aad7ee5b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"при упоминании города, года в тексте — слова «город», «год» можно опустить, если человеку будет понятно, что речь именно про город или год "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d50f49d9-610d-4995-8a47-7123b0bea289",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b736ea30-ed1e-408f-af90-5e9a9b179b73",
			"type": "column_list",
			"content": [
				"7e26a7bd-014e-4576-8276-72827d577d8f",
				"62e290ca-58bb-4e60-b275-3fe8bdebd2a6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "49252190-dbf9-4e93-9f5a-bec79aa259ee",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d0629d6a-24ca-4aa4-8118-2d1c2875272a",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Сокращение времени, расстояний и других названий  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b3a40f65-14c8-4b87-ace9-fe09bebf0047",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a478e6f4-f1a6-4d1d-9386-d81ed825f9d2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "94161272-ed3b-407d-a663-07ea86898463",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eb9308c1-642f-4473-b805-1ca17b9103bf",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"используем общепринятые сокращения по правилам русского языка"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "56d25876-7de7-4ca5-949a-5a10ee619ac6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc2c3533-d089-470a-bb23-1b6cc1ec086d",
			"type": "image",
			"properties": {
				"size": [
					[
						"54.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/44437164-24c1-4dbb-857d-c21de37763e5/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/44437164-24c1-4dbb-857d-c21de37763e5/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.46,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"44437164-24c1-4dbb-857d-c21de37763e5"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fc2c3533-d089-470a-bb23-1b6cc1ec086d.png"
		},
		{
			"id": "33d16604-a004-4415-8cf4-dc30c0fe7509",
			"type": "callout",
			"properties": {
				"title": [
					[
						"revenue продукта 300 трлн руб. \n\nоферта, договор и т. д. \n\nвремя по мск"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d070b105-3101-47c6-be78-9c532a7f9a6d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce76612e-ef9c-46fe-8fee-7731d44001f2",
			"type": "header",
			"properties": {
				"title": [
					[
						"Оформление   "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "443f893d-4a0e-4095-b13a-738e6673bcde",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e338623-1dbf-4287-bba1-8840145658f4",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Буква «Ё»"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "83e94871-6dc5-4583-9a8f-76c48d03b18c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab36c114-9f95-4abf-ac5f-dff950ca97b0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем букву «ё» везде, где она есть в слове. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1b1df1a9-78c8-46ac-88de-f5496f42498f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d81b1dbe-5171-4268-9883-1feb498489b4",
			"type": "column_list",
			"content": [
				"48ea9eac-405e-40e1-b549-7586b7eccaa3",
				"e53baf97-dfbb-4aa4-91fb-620af5f9e0c4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f10aaad9-9ad8-41f3-9c07-374e1a99072f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69bfd80b-4d98-4d5f-8329-c50e9fb7f9bb",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Предлоги и союзы "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e7b4fe0d-8630-44d5-ab76-7d7803f2c1af",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "22211ae8-ff2f-4900-968e-afb941786d25",
			"type": "text",
			"properties": {
				"title": [
					[
						"Висящие предлоги и союзы создают визуальный шум и делают текст неопрятным. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "35fa468c-2d3d-4dd5-95f8-52fba3f78349",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c41ed3d6-704e-4170-b9d1-24539918ed54",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "78c02a72-8ba6-4911-86f3-1545d0178d29",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7bd49bd4-9d41-4462-94a4-0d2863c829d9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не оставляем «висяки» в конце строки — всегда переносим на новую"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b6884138-cb61-4f34-b95d-cfebfc8faaa5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a80c38f-56ec-44d0-bf77-09e812fd9ba3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "db757e0c-3edc-4763-b250-603d06906341",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a95e6b26-2c6b-4305-b882-7571c7224a2b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если короткое слово или предлог из трёх букв — можно не переносить "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aac563a2-e88b-465b-82bc-80d7103cfeb3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd29da27-f4d5-4f83-bdb4-95907d57a692",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"нарушаем правило, если при переносе «висяка» едет вёрстка в макете "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7d87b650-e650-403d-8729-7107461ef2ff",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83cfec5b-d752-4ae7-9d25-97df99c1636f",
			"type": "column_list",
			"content": [
				"6362d96a-a35c-423d-bbe0-14b654f5605c",
				"14787544-e486-456a-879e-cd72420e605c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ec5cbb98-af05-42d8-b84b-c6e2b097dda0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5b3f990a-0c29-48c9-8be3-7b70159c335f",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Номер телефона"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "75eb748a-ab9d-40f6-93b9-bb9df089ef10",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2164216b-58b1-4061-9e1c-73fb7e9f0e00",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0e29d668-18dd-4b11-8a40-fd4a79f58f84",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "693a0267-9a29-4de1-aaf1-4f0b7314a330",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"единственно верный формат:  +7 999 ХХХ-ХХ-ХХ"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3d539ba5-3a15-4732-b04e-341233d8f603",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8e3f6f17-09c7-46a3-912e-474f9a6438ee",
			"type": "column_list",
			"content": [
				"a0ec8a39-5d34-44a0-ab59-cd3aeab259d6",
				"560ae7e2-c7e1-4af1-a7cc-b58cdc7832ff"
			],
			"format": {
				"copied_from_pointer": {
					"id": "163351c4-1828-4d34-91ed-65884a3a8073",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7e646642-b1e9-479d-a8a5-de936268e51b",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Десятичные дроби"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bfd9a192-9e71-4341-86bc-20bd2cd36eba",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0795bdb2-db57-44a6-be16-9eddc74de687",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "20ae418b-5a6b-46d7-8f1b-b75fbe1d5474",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d4caf80-a58c-460f-8748-6ba351decfe1",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"в десятичных дробях используем запятую"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "da9c24a9-2a1d-4152-b73a-7fb3853f51c3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2229a919-0731-4a7c-ae53-44da39f58f76",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0d0c5d81-e4cb-4ed3-a331-071f066df536",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2192aec2-2be7-4b53-8539-002da144b0be",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"вся коммуникация, связанная с Облаком — используем точку "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "06b6ecc8-6bbb-42aa-bc11-b38fa0c145ed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91b8836e-910a-4202-a671-5191658c3c6f",
			"type": "column_list",
			"content": [
				"3e6bdd7d-ab28-4c17-972a-ba82e1de949a",
				"68be75ea-0732-407b-a595-4d2e31788cd6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "4b2bd310-6190-46b3-80e0-081afd089761",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d99eedef-af7f-47c7-98f1-542431006a77",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Четырёхзначные и более числа "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "950b49ca-8eaf-479a-aa2a-9754f9330489",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6a6cf3ab-8918-4869-b829-c4fed80c9c63",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем маски для общепринятых форматов чисел (номера счетов, карты, серия и номер паспорта, СНИЛС, ИНН и др.). В маске каждую группу чисел отделяем друг от друга пробелами. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4b6b6729-d206-4d53-a628-51207e61f90e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e018734-1203-42c1-b7d4-c044f46f9a23",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5c67f833-963a-4cba-aef0-752ea58cc50e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "99e6dcfd-9570-4775-bca4-566213bc5930",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"четырёхзначное число и более — пробел через каждые 3 цифры справа налево"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "54214a5d-4859-461c-a6d0-b2a5a2037ac1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "867159db-0242-42d7-a7bb-3c8f6a94107a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"копейки в сумме отделяются запятой, после запятой без пробела "
					],
					[
						"(исключение: Облако)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9d89c35e-801b-485b-aad4-8d6c2c9abdb4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "63115f1d-d7d9-47a2-9a61-77da52492bd9",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"номер счёта — пробел через каждые 5, 3, 1, 4, 7 цифры"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0e679bb4-41f4-4d69-93d4-082ec54df946",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "767cc406-9dd9-48a8-9d1b-37d49db38048",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"номер карты — пробел через каждые 4 цифры"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "04aea5c9-2430-48d9-bbc9-7e4236a1e197",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa386ac4-aa45-4a1e-8080-e89cf3c94a75",
			"type": "column_list",
			"content": [
				"078b6f0e-f7db-43cb-8f4b-af27ffb85599",
				"ec7c71c1-07d1-4b36-8c9c-193a76ff9c58"
			],
			"format": {
				"copied_from_pointer": {
					"id": "96725aff-20b6-4b35-a503-9e9abf9d4b0c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "99926722-2bd3-45c5-8248-0ddebbc4a781",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Числительные "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "de821192-e2f5-4c3c-87d1-0dcd3a41314c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95c4c98e-8282-499a-8384-af1b747516d0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c6705334-478c-4547-9cdb-d2699700c3db",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b703737-1d61-4014-ba51-e1717ae3bf84",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если в предложении одно числительное — можем писать как цифру, так и слово "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "929f748f-8489-41f7-adb3-de886a10e916",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7b364f9-2afe-4514-9baf-3a6ac7ee199c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если в предложении больше, чем одно числительное — всё пишем цифрами"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "96a2011e-6326-426f-b90b-56314be396aa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "87c0dd4e-d623-4a32-bf4b-af44bc880873",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не наращиваем числительные, если при этом понятно, как его прочитать "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "342904cb-9b97-4038-8b57-deb81e7523e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e3f41409-78be-4ffd-81a1-1ce88cb82149",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"слова склоняются"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "62504d48-365f-4698-b677-e4dbfdeef0a0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "25a3c4d4-8ed6-445c-8a37-327959326654",
			"type": "column_list",
			"content": [
				"e4445602-500c-47c3-9a08-b7a495997b68",
				"c66babae-7e50-4701-b60c-f7337abe4ff1"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9fc17931-14a9-47e6-9538-16f74628b2cc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "367acd50-8ba8-4927-aed6-f47efe3a0758",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Даты "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5326434e-7c43-4ba2-852b-207f58979756",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1a73d788-ae3a-4d96-a0bd-d8c400642815",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "445f6109-bc14-4de2-8979-4765f22be76c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "08587d4c-6969-4a23-8703-27f18166386d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"для даты допустимо 3 формата: 7 ноября 2024, 07.11.24, 7 ноября (если контекстно понятно, в какой год)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "61556703-932c-44a6-bb27-986f3f603419",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26b577fc-a430-4bf2-87cb-8c23624c82b4",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"названия дней недели, месяцев пишем с маленькой буквы. Допустимы сокращения без точки в конце: пн, вт, ср, чт, пт, сб, вс, янв, фев, мар, апр, май, июн, июл, авг, сен, окт, ноя, дек"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "270847ba-01ab-4128-96b5-e6d994013c59",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6921bed0-20e4-483f-a94c-88fed7c9f3b3",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"слово «год» всегда пишем полностью, не сокращаем до «г.»"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a96278b3-bf65-4ca5-baf6-f19509f96b40",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65c88c7b-f9c6-4d61-ab87-c3adfb190ea0",
			"type": "column_list",
			"content": [
				"35aa1991-c325-4e58-9fa8-a8acd767d813",
				"c7778ae4-a21a-48d6-8217-2f549e664e64"
			],
			"format": {
				"copied_from_pointer": {
					"id": "326c418f-723c-41ed-897f-076dfafb5f63",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ee5f046f-bf9c-46ed-8b21-54dd5c8faed8",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Точки в конце предложения  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f37aa945-e276-4c38-8d3d-6bb4ecb8f5f7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9bf18ef3-5485-447b-860d-80aa00028051",
			"type": "text",
			"properties": {
				"title": [
					[
						"Главное правило в вопросе «ставить или не ставить точку» — ваше ощущение. Следуйте правилу, но если понимаете, что для единообразия или консистентности его можно нарушить — нарушайте. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d7fadd35-3427-4ed8-bf27-344c026ea7bb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fbb0a142-c9e3-4d45-9693-fd33c4e5faa7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a2415778-1ed2-48e4-af2f-ed4acfcf1dad",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "798988ed-10ff-4277-b77d-a0ec50f0cac3",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не ставим точку в заголовках, названиях полей, плейсхолдерах, кнопках, подписях к полям"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7e14a396-7de1-4093-aab7-03828b3d5a53",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0aee1653-878d-4179-93de-b02de477a4ad",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"не ставим точку в тексте, если он состоит из одного предложения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "10996b9a-d58b-4046-9170-198dbb32023a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "82d4a397-891f-41da-8789-a6d2ccc72066",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если абзац один — в последнем предложении точку в конце не ставим "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dafcca65-2367-48e8-8248-8d8921168587",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72cec629-bc0b-4028-96d6-9a3fa9c9ce8a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если абзацев несколько — ставим точку после каждого предложения "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f09e378c-5344-4ff5-a1f5-7ee596f88283",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9d1ac02d-0a22-49fa-a7d2-7f31dee5d3db",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/47a4dcac-49e2-448c-8b59-0946638e4bfe/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/47a4dcac-49e2-448c-8b59-0946638e4bfe/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"47a4dcac-49e2-448c-8b59-0946638e4bfe"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9d1ac02d-0a22-49fa-a7d2-7f31dee5d3db.png"
		},
		{
			"id": "24429c10-0780-47ef-a48b-4003d684125a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Попробуйте заморозку \n\nЕсли подписка сейчас не нужна, заморозьте её и сохраните оплаченные дни\n"
					],
					[
						"(пример текста на модальном окне)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5c53de10-6626-4b46-8f37-0e7332f6c224",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "80b8d76f-330e-4c8b-9daa-88cc956cf34c",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "b061981b-8be6-4561-8e1d-6ce2254a2bd1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0b28bf06-4022-49ad-8aed-c46fc98ea94c",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Списки  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eff0064a-39c8-4fa0-b766-07c7c6a41efd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4b1fab60-a2cf-4668-a8ca-5af98f17bf74",
			"type": "text",
			"properties": {
				"title": [
					[
						"Списки помогают визуально структурировать информацию и направить внимание читателя. У нас есть несколько вариантов списков — выбирайте тот, который уместен в контексте. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e793402c-c0e4-41fc-bd2b-a73e3e8bc124",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "17c15744-9d7e-4cb3-b197-1fec9dfc2d0b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Нумерованный список — используем"
					],
					[
						" ",
						[
							[
								"b"
							]
						]
					],
					[
						"в инструкциях help.mail"
					],
					[
						" ",
						[
							[
								"b"
							]
						]
					],
					[
						"и для описания  последовательности шагов. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9b83f9c4-3b3f-48a9-8078-929deb642436",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0588d1c7-0fa5-4879-8ed2-cd25b4702b4c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "707501ec-cdb6-4344-ad19-1518874a9a12",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "63144ddc-a46a-4649-bbc1-39e5fdd7cf18",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"заголовок списка — с заглавной буквы, без знака препинания в конце "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6d8ee0e4-690d-4d33-a1f3-c94eab103d93",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67631b8d-011a-41cf-84ae-bd4de3c9222d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"каждый новый пункт начинаем с нумерации, далее следует предложение \nс заглавной буквы и точкой в конце "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b5e371f1-551e-436c-9008-092a208b298d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3e2d121-418e-4da6-a5df-7e80ae22de3c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/064a7b45-bd53-47d1-a48b-c071f6660968/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/064a7b45-bd53-47d1-a48b-c071f6660968/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"064a7b45-bd53-47d1-a48b-c071f6660968"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c3e2d121-418e-4da6-a5df-7e80ae22de3c.png"
		},
		{
			"id": "250343d6-b2c3-46d3-a847-29df56095400",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Как изменить пароль\n1. Перейдите в настройки. \n2. Нажмите «Изменить пароль»."
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9bdcd0df-15bb-4d1e-834b-5824af4fe851",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c72b3cf6-ff23-4acf-a78c-803e23681d62",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "9c6a6058-be8a-426e-a075-36a5d87f1ba5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3aaa4782-f3fa-405b-ac69-11f16930cce1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Облегчённый или маркированные список — для описания равнозначных пунктов.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9c6a6058-be8a-426e-a075-36a5d87f1ba5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "71977311-dc33-4b41-9f51-54fc005077bf",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "160ccc20-657a-4597-ad36-0a25e78c7bb8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ec7497fd-e5c7-4c14-9f35-2e5ab67ed67e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"заголовок — с заглавной буквы, в конце — либо знака нет, либо «:» "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8b0a4e16-6c4a-43d0-8265-95188bbafa1d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3530cf3-2944-4905-aa43-b08b560f7c34",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"каждый пункт списка пишем со строчной или заглавной буквы, в конце — без знака препинания"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f114ab48-0dc8-406a-9d0d-018ffce0234e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "42b7e358-1861-442a-885c-65f21e87501f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"в последнем пункте списка — без точки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "396106fe-977a-4e17-902c-b45b27f3cbea",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "770c2979-86b0-49ec-8d2f-9336abe987a9",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21a96590-4a0b-4878-b3b1-cbba271f961d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21a96590-4a0b-4878-b3b1-cbba271f961d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"21a96590-4a0b-4878-b3b1-cbba271f961d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/770c2979-86b0-49ec-8d2f-9336abe987a9.png"
		},
		{
			"id": "9b5069be-cb97-46e5-9753-d81336a4e5a2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"С VK Тутория репетитор сможет\nвести уроки там, где удобно: \n– создавать интерактивные занятия\n– делиться ссылками вместо распечаток"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a6cbc7ba-69e4-45e6-82a6-7d0c4013b1f2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c6769157-8a9e-49e4-aaea-b8c9150c3626",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Ссылки "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "27cf9217-c151-4db3-8cd8-39471c5cec88",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d5236a0e-e6be-4b2e-9279-dd23524e20dc",
			"type": "text",
			"properties": {
				"title": [
					[
						"Ссылки часто используют по тексту при нативном упоминании продукта, сервиса, источника или документа. Размещать кнопки не всегда бывает уместным — в таких ситуациях как раз спасают ссылки. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "20cb6b7e-5990-474d-b244-dcf78273396c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ca558d4d-8988-45cd-a80b-a71082ef300c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4a0b66df-a195-4383-bc39-f55812937ede",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4417056c-5ce5-4967-8ad3-835cb1ec9eec",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"ссылку можно выделить цветом — чаще синим"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6356bc08-abfb-4468-876e-afad03e0bde5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "61ebfc7a-3235-48aa-b1c8-c47c9b4cc04b",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"допустимо, но необязательно подчёркивание"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fc128411-7615-452e-b2eb-edd48c12e0df",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0e29b335-31f2-442e-ad17-13d0948e3913",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"ссылка должна однозначно определять то, что увидит человек после перехода \nпо ней — то есть линкуется смысловая фраза целиком, «читайте тут», «скачать здесь» недопустимы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3c4e8a39-6649-406d-99a4-a2cff7807e50",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "faedf7a6-2bc5-4998-8e7c-c41a2ccb3c17",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"линкуется минимальное количество слов, но так, чтобы смысл был передан "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "630b4d14-9d31-47b4-9d7b-818b4e290b45",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4cacf52f-9944-4144-bc50-84d0554cd2d0",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"точку после ссылки в конце абзаца можно не ставить "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "926a0710-9a0f-42ed-8eb7-36a6db486831",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fdf13b95-9b68-4efb-88f8-390b5e7774fb",
			"type": "column_list",
			"content": [
				"93455b07-e2b6-4cc2-a59d-8fd66d4043d7",
				"152449e1-54b5-4487-9ea9-916437e043b4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "bff02820-b4fb-4803-afdd-70284fc1624d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1fe10717-caaa-4498-8b08-e0b4c7e5c025",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Файлы куки и рекомендательные технологии "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cb10b150-e399-497c-b82d-496daf7227ac",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c1fec180-404b-4d19-a530-7a74b5acb6d9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правила",
						[
							[
								"b"
							]
						]
					],
					[
						" "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2a125c89-9319-4062-8c1f-c47b43c71397",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2da7dc83-ede5-4a77-9f55-c3fce7499e6f",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"пишем слово на кириллице: куки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c281725a-54a2-4916-9cfa-56fce0fe26c6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d2d44330-4b73-4acf-8ca5-a28b5dae4c92",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"линкуем фразы так: "
					],
					[
						"используем файлы куки",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" и "
					],
					[
						"рекомендательные технологии",
						[
							[
								"h",
								"default"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e9485ff9-b2f5-4650-9ba6-838389b534ae",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c8217d95-472c-4300-a93c-1aa84a2dc9aa",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"используем любую из четырёх формулировок ниже:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c781b8bc-7089-4957-94c3-ac0a28000d1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "da6ce7b2-c4f4-4d53-b4f3-17b5516e5e4a",
			"type": "column",
			"content": [
				"04b05fd9-5064-4de7-aa73-6ab9a39c7a76",
				"c6a3895c-e50e-4d7b-9610-7ce0c9d5cb6c"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "f8df85c2-fbea-49b8-bc70-3ede8034ab94",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "15929992-132c-4af9-8ac4-569a0a3bfe93",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b86822b0-3060-47a1-80fc-09c06ba9661f",
			"type": "column",
			"content": [
				"6a111765-eda1-474d-bd3c-2c2af6cd340a",
				"3516826e-6418-48eb-a70b-04654eb5d925"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "03ba34c1-72f9-4a67-9bce-ee6dc209784b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "15929992-132c-4af9-8ac4-569a0a3bfe93",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "04b05fd9-5064-4de7-aa73-6ab9a39c7a76",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cb35827c-4b70-4cbe-93e7-1b062c8082f6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cb35827c-4b70-4cbe-93e7-1b062c8082f6/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "da6ce7b2-c4f4-4d53-b4f3-17b5516e5e4a",
			"parent_table": "block",
			"file_ids": [
				"cb35827c-4b70-4cbe-93e7-1b062c8082f6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/04b05fd9-5064-4de7-aa73-6ab9a39c7a76.png"
		},
		{
			"id": "c6a3895c-e50e-4d7b-9610-7ce0c9d5cb6c",
			"type": "callout",
			"properties": {
				"title": [
					[
						"подписка Mail Space \n\nсохранить на Диск-О:\n\nСмотрите в разделе "
					],
					[
						"Инструкции",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d6a6517b-d754-4ef0-b79d-e0225e1138a2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "da6ce7b2-c4f4-4d53-b4f3-17b5516e5e4a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6a111765-eda1-474d-bd3c-2c2af6cd340a",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b50ae02c-a459-4a66-8235-360471e3184c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b50ae02c-a459-4a66-8235-360471e3184c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "b86822b0-3060-47a1-80fc-09c06ba9661f",
			"parent_table": "block",
			"file_ids": [
				"b50ae02c-a459-4a66-8235-360471e3184c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6a111765-eda1-474d-bd3c-2c2af6cd340a.png"
		},
		{
			"id": "3516826e-6418-48eb-a70b-04654eb5d925",
			"type": "callout",
			"properties": {
				"title": [
					[
						"подписка «Mail Space»\n\nсохранить на «Диск-О:»\n\nСмотрите в разделе \n"
					],
					[
						"инструкций",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "4de64567-6da2-4c47-b12f-8b3ecc8c02b3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b86822b0-3060-47a1-80fc-09c06ba9661f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7e26a7bd-014e-4576-8276-72827d577d8f",
			"type": "column",
			"content": [
				"0778d286-09c9-418f-a7ab-7b68ff055d98",
				"8ea09597-20c0-45c3-b736-6caba3b3a9ef"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "c0ddb21b-bc78-4a84-b3cb-194fb7d6f129",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b736ea30-ed1e-408f-af90-5e9a9b179b73",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "62e290ca-58bb-4e60-b275-3fe8bdebd2a6",
			"type": "column",
			"content": [
				"182f6251-1fe6-47c0-8974-202c7e35c70e",
				"b7ef899d-59cc-466e-8ba7-68c4ab072e25"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "81826823-f851-43c3-a52e-3e851fcdbd1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b736ea30-ed1e-408f-af90-5e9a9b179b73",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0778d286-09c9-418f-a7ab-7b68ff055d98",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5f00d207-7c7f-4c66-90d1-242f364a94ef/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5f00d207-7c7f-4c66-90d1-242f364a94ef/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "7e26a7bd-014e-4576-8276-72827d577d8f",
			"parent_table": "block",
			"file_ids": [
				"5f00d207-7c7f-4c66-90d1-242f364a94ef"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0778d286-09c9-418f-a7ab-7b68ff055d98.png"
		},
		{
			"id": "8ea09597-20c0-45c3-b736-6caba3b3a9ef",
			"type": "callout",
			"properties": {
				"title": [
					[
						"г. Нижний Новгород, ул. Парковая, д. 3, корп. 1а, кв. 15\n\nв офисе компании в Перми\n\nтариф действует до конца 2025 года\n"
					],
					[
						"(уместно в юр. документах)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d7ca4055-7491-4cb1-a383-4c059a5d075e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7e26a7bd-014e-4576-8276-72827d577d8f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "182f6251-1fe6-47c0-8974-202c7e35c70e",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/08c3626c-367b-484a-b683-8cf5277d26ee/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/08c3626c-367b-484a-b683-8cf5277d26ee/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "62e290ca-58bb-4e60-b275-3fe8bdebd2a6",
			"parent_table": "block",
			"file_ids": [
				"08c3626c-367b-484a-b683-8cf5277d26ee"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/182f6251-1fe6-47c0-8974-202c7e35c70e.png"
		},
		{
			"id": "b7ef899d-59cc-466e-8ba7-68c4ab072e25",
			"type": "callout",
			"properties": {
				"title": [
					[
						"г.Москва, ул.Зои Космодемьянских, д.20, кв.100"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ec49d820-8a00-42ef-9a10-a6ccfd46d698",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "62e290ca-58bb-4e60-b275-3fe8bdebd2a6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "48ea9eac-405e-40e1-b549-7586b7eccaa3",
			"type": "column",
			"content": [
				"229551ca-9db1-4f6b-bab5-2fe425bb16f0",
				"3d541a41-90f1-47f8-95d6-7247f906b97b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "084e8aac-69c0-432d-a9d7-dc61f9886947",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d81b1dbe-5171-4268-9883-1feb498489b4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e53baf97-dfbb-4aa4-91fb-620af5f9e0c4",
			"type": "column",
			"content": [
				"3f577a71-0a26-411a-8fb0-9378adf36dce",
				"93e6c085-8c02-4d90-a455-e5b935e10d2a"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "26e28df8-d383-4a0b-b8e4-8f1734dc6fa2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d81b1dbe-5171-4268-9883-1feb498489b4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "229551ca-9db1-4f6b-bab5-2fe425bb16f0",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/74d6e1f2-5b85-4274-9ae2-6ae9c568482d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/74d6e1f2-5b85-4274-9ae2-6ae9c568482d/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "48ea9eac-405e-40e1-b549-7586b7eccaa3",
			"parent_table": "block",
			"file_ids": [
				"74d6e1f2-5b85-4274-9ae2-6ae9c568482d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/229551ca-9db1-4f6b-bab5-2fe425bb16f0.png"
		},
		{
			"id": "3d541a41-90f1-47f8-95d6-7247f906b97b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"платформа для учёбы "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "808db9c4-220f-4f35-802e-7e1f59bbd065",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "48ea9eac-405e-40e1-b549-7586b7eccaa3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3f577a71-0a26-411a-8fb0-9378adf36dce",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b6d2478-253d-4bc0-843e-e3f4c134616b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b6d2478-253d-4bc0-843e-e3f4c134616b/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "e53baf97-dfbb-4aa4-91fb-620af5f9e0c4",
			"parent_table": "block",
			"file_ids": [
				"1b6d2478-253d-4bc0-843e-e3f4c134616b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3f577a71-0a26-411a-8fb0-9378adf36dce.png"
		},
		{
			"id": "93e6c085-8c02-4d90-a455-e5b935e10d2a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"показать еще"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ffc4b5fb-b87d-4f79-a7c4-4c60b1435c6b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e53baf97-dfbb-4aa4-91fb-620af5f9e0c4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6362d96a-a35c-423d-bbe0-14b654f5605c",
			"type": "column",
			"content": [
				"5b764ef9-98df-4cc6-96ec-8e66bca0bbbb",
				"3b907bc3-6dee-41bf-bedb-887de855b7a5"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "fdc63671-b264-4876-ac58-0613637b23f0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "83cfec5b-d752-4ae7-9d25-97df99c1636f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "14787544-e486-456a-879e-cd72420e605c",
			"type": "column",
			"content": [
				"cdc3bfe0-0a53-4c63-b8f5-9ec59c85785c",
				"45941461-4978-4807-84cb-a94c2cf9a6e7"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "2e8277f9-36d8-4b14-bfcf-ee1e1fd21cf4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "83cfec5b-d752-4ae7-9d25-97df99c1636f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5b764ef9-98df-4cc6-96ec-8e66bca0bbbb",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ed957967-4c0e-49ec-a71d-a458b834d3ac/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ed957967-4c0e-49ec-a71d-a458b834d3ac/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6362d96a-a35c-423d-bbe0-14b654f5605c",
			"parent_table": "block",
			"file_ids": [
				"ed957967-4c0e-49ec-a71d-a458b834d3ac"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5b764ef9-98df-4cc6-96ec-8e66bca0bbbb.png"
		},
		{
			"id": "3b907bc3-6dee-41bf-bedb-887de855b7a5",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Продуктивити сервисы: Календарь и Заметки"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c987e0f8-1d6d-4f88-9d10-49aa965b9547",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6362d96a-a35c-423d-bbe0-14b654f5605c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cdc3bfe0-0a53-4c63-b8f5-9ec59c85785c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b393d1b7-df85-49eb-82ba-4f517c588812/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b393d1b7-df85-49eb-82ba-4f517c588812/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "14787544-e486-456a-879e-cd72420e605c",
			"parent_table": "block",
			"file_ids": [
				"b393d1b7-df85-49eb-82ba-4f517c588812"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/cdc3bfe0-0a53-4c63-b8f5-9ec59c85785c.png"
		},
		{
			"id": "45941461-4978-4807-84cb-a94c2cf9a6e7",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Продуктивити сервисы: Календарь и \nЗаметки"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6c5ca4f2-35d7-4e95-b63e-e85e3821f702",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "14787544-e486-456a-879e-cd72420e605c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0ec8a39-5d34-44a0-ab59-cd3aeab259d6",
			"type": "column",
			"content": [
				"72de7a6c-ff47-4ded-9161-c2d1044e39a1",
				"455452cf-b5e3-4fc1-ac29-616301a895ef"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "6317b6b3-027d-41f7-afc2-45b2a6a1390e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8e3f6f17-09c7-46a3-912e-474f9a6438ee",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "560ae7e2-c7e1-4af1-a7cc-b58cdc7832ff",
			"type": "column",
			"content": [
				"de8fbb3c-ef3f-452c-9a39-bfa4ea57deb5",
				"f591efb2-5e05-4805-97ca-acbd65665f5f"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "e71b4de0-9a80-4844-a6f7-29b5bd9703aa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8e3f6f17-09c7-46a3-912e-474f9a6438ee",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "72de7a6c-ff47-4ded-9161-c2d1044e39a1",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/811e1e1b-7a77-4c90-b557-923244811ee9/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/811e1e1b-7a77-4c90-b557-923244811ee9/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "a0ec8a39-5d34-44a0-ab59-cd3aeab259d6",
			"parent_table": "block",
			"file_ids": [
				"811e1e1b-7a77-4c90-b557-923244811ee9"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/72de7a6c-ff47-4ded-9161-c2d1044e39a1.png"
		},
		{
			"id": "455452cf-b5e3-4fc1-ac29-616301a895ef",
			"type": "callout",
			"properties": {
				"title": [
					[
						"+ 7 800 123-45-67 "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "22e3d2b8-6b29-4c1b-b341-19c39dde3481",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a0ec8a39-5d34-44a0-ab59-cd3aeab259d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de8fbb3c-ef3f-452c-9a39-bfa4ea57deb5",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/582a54e6-97f0-48e0-97f9-94686cf563f4/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/582a54e6-97f0-48e0-97f9-94686cf563f4/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "560ae7e2-c7e1-4af1-a7cc-b58cdc7832ff",
			"parent_table": "block",
			"file_ids": [
				"582a54e6-97f0-48e0-97f9-94686cf563f4"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/de8fbb3c-ef3f-452c-9a39-bfa4ea57deb5.png"
		},
		{
			"id": "f591efb2-5e05-4805-97ca-acbd65665f5f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"88001234567\n\n7 (495) 800-20-10"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "cd0ff10c-abf0-4c60-80b9-4ebad2d45453",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "560ae7e2-c7e1-4af1-a7cc-b58cdc7832ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3e6bdd7d-ab28-4c17-972a-ba82e1de949a",
			"type": "column",
			"content": [
				"fa0e4192-c099-47d3-ad9f-04d50793d248",
				"56db29d2-6c5c-4fd5-be9d-ff910601a883"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "9d91797a-c69d-4694-b088-4e63c5363830",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91b8836e-910a-4202-a671-5191658c3c6f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "68be75ea-0732-407b-a595-4d2e31788cd6",
			"type": "column",
			"content": [
				"079a37da-1678-4004-a7db-4c310d524182",
				"652c47ec-c6c5-4712-bb22-bc592f6366d1"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "3011d079-2ece-4b20-aa56-56b87a245068",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91b8836e-910a-4202-a671-5191658c3c6f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa0e4192-c099-47d3-ad9f-04d50793d248",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ebe95f9-881a-448f-963a-d62c129e4bb8/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ebe95f9-881a-448f-963a-d62c129e4bb8/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "3e6bdd7d-ab28-4c17-972a-ba82e1de949a",
			"parent_table": "block",
			"file_ids": [
				"0ebe95f9-881a-448f-963a-d62c129e4bb8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fa0e4192-c099-47d3-ad9f-04d50793d248.png"
		},
		{
			"id": "56db29d2-6c5c-4fd5-be9d-ff910601a883",
			"type": "callout",
			"properties": {
				"title": [
					[
						"метрика NPS 55,5 \n\nдополнительные 127.5 ГБ \nв вашем Облаке "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "052d598f-ab78-4c5b-bc9d-01db2bf08156",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3e6bdd7d-ab28-4c17-972a-ba82e1de949a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "079a37da-1678-4004-a7db-4c310d524182",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c0138a90-aeec-4437-8e1b-7c1f11073f6c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c0138a90-aeec-4437-8e1b-7c1f11073f6c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "68be75ea-0732-407b-a595-4d2e31788cd6",
			"parent_table": "block",
			"file_ids": [
				"c0138a90-aeec-4437-8e1b-7c1f11073f6c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/079a37da-1678-4004-a7db-4c310d524182.png"
		},
		{
			"id": "652c47ec-c6c5-4712-bb22-bc592f6366d1",
			"type": "callout",
			"properties": {
				"title": [
					[
						"выкатили релиз на 99.9 процентов "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "802ac245-070c-4e49-aeb6-de5cc28160c9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "68be75ea-0732-407b-a595-4d2e31788cd6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "078b6f0e-f7db-43cb-8f4b-af27ffb85599",
			"type": "column",
			"content": [
				"c89dd3b0-d9b0-473b-80db-7980b05bc52b",
				"3cc03417-5c52-4d45-8513-b7fbbb8e79bd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "ba403455-31fb-404e-8031-0ca4bba11e76",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aa386ac4-aa45-4a1e-8080-e89cf3c94a75",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ec7c71c1-07d1-4b36-8c9c-193a76ff9c58",
			"type": "column",
			"content": [
				"1eebe69d-5847-4912-810e-00695ed39a69",
				"71affdbd-a35f-48f0-bf09-b6ec59c83972"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "04faec74-67c2-4d6d-9ff4-564d7dceaf70",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aa386ac4-aa45-4a1e-8080-e89cf3c94a75",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c89dd3b0-d9b0-473b-80db-7980b05bc52b",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/271dd144-b523-49fe-9350-9ffa3adf853b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/271dd144-b523-49fe-9350-9ffa3adf853b/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "078b6f0e-f7db-43cb-8f4b-af27ffb85599",
			"parent_table": "block",
			"file_ids": [
				"271dd144-b523-49fe-9350-9ffa3adf853b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c89dd3b0-d9b0-473b-80db-7980b05bc52b.png"
		},
		{
			"id": "3cc03417-5c52-4d45-8513-b7fbbb8e79bd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"наша цель — 5 000 новых пользователей в день\n\nстоимость тарифа в Облаке \n99.9 ₽ в месяц "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "743ac657-0fcc-4ec9-ad1b-c01e1bf0a28d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "078b6f0e-f7db-43cb-8f4b-af27ffb85599",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1eebe69d-5847-4912-810e-00695ed39a69",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/87835da2-4daa-42df-ba24-5137f36d1fab/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/87835da2-4daa-42df-ba24-5137f36d1fab/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "ec7c71c1-07d1-4b36-8c9c-193a76ff9c58",
			"parent_table": "block",
			"file_ids": [
				"87835da2-4daa-42df-ba24-5137f36d1fab"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1eebe69d-5847-4912-810e-00695ed39a69.png"
		},
		{
			"id": "71affdbd-a35f-48f0-bf09-b6ec59c83972",
			"type": "callout",
			"properties": {
				"title": [
					[
						"мы заработали 10000 млн ₽\n\n\nподписка на год 12000.0 рублей "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f65d6e51-6aee-42fc-9170-17ea2b6f5b61",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ec7c71c1-07d1-4b36-8c9c-193a76ff9c58",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e4445602-500c-47c3-9a08-b7a495997b68",
			"type": "column",
			"content": [
				"058685f7-68e9-4b46-ba5f-27c2047d6b33",
				"71b83932-7f45-4d01-9af3-a00c3d29863e"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "36b68624-ded7-4b1b-be46-7826b5a12c63",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "25a3c4d4-8ed6-445c-8a37-327959326654",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c66babae-7e50-4701-b60c-f7337abe4ff1",
			"type": "column",
			"content": [
				"7dd0f132-4624-4d42-9fa6-80ceab7046aa",
				"75a3f12c-e186-44a4-89e8-f16f9fcebf21"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "9e1321be-6a2f-47bc-9dc2-914fbce157aa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "25a3c4d4-8ed6-445c-8a37-327959326654",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "058685f7-68e9-4b46-ba5f-27c2047d6b33",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b5f64b1-652f-425a-99be-7d902b84698b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b5f64b1-652f-425a-99be-7d902b84698b/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "e4445602-500c-47c3-9a08-b7a495997b68",
			"parent_table": "block",
			"file_ids": [
				"0b5f64b1-652f-425a-99be-7d902b84698b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/058685f7-68e9-4b46-ba5f-27c2047d6b33.png"
		},
		{
			"id": "71b83932-7f45-4d01-9af3-a00c3d29863e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Тариф подключается за 2 шага \n\nТариф подключается за два шага \n\nВ пунктах 1 и 3 стоит учесть…"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "49d4999e-8020-46af-a8cf-6c7e2edbfb35",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e4445602-500c-47c3-9a08-b7a495997b68",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7dd0f132-4624-4d42-9fa6-80ceab7046aa",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4f3e1ecf-2dec-4daf-9e62-e071e293c25f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/4f3e1ecf-2dec-4daf-9e62-e071e293c25f/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c66babae-7e50-4701-b60c-f7337abe4ff1",
			"parent_table": "block",
			"file_ids": [
				"4f3e1ecf-2dec-4daf-9e62-e071e293c25f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7dd0f132-4624-4d42-9fa6-80ceab7046aa.png"
		},
		{
			"id": "75a3f12c-e186-44a4-89e8-f16f9fcebf21",
			"type": "callout",
			"properties": {
				"title": [
					[
						"в пункте № три \n\nв 1-ом пункте \n"
					],
					[
						"(понятно и без -ом, как правильно прочитать)",
						[
							[
								"i"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "2a52f975-8032-4708-9b57-b11e0f779daa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c66babae-7e50-4701-b60c-f7337abe4ff1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35aa1991-c325-4e58-9fa8-a8acd767d813",
			"type": "column",
			"content": [
				"24542f8c-6b0c-4746-a034-f7fb5bc590e9",
				"d5af9518-b1ba-4efc-863c-a5b662f52d0b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5e338110-69ca-47d8-86c7-7eb40b1e39e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "65c88c7b-f9c6-4d61-ab87-c3adfb190ea0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c7778ae4-a21a-48d6-8217-2f549e664e64",
			"type": "column",
			"content": [
				"6fa7e67b-12f8-4726-b5ab-d6605b78db70",
				"0df2c741-0ae7-4212-9ae9-422931c207e5"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "e4c02a9f-f8bc-48ca-8719-b8d35ab3d82d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "65c88c7b-f9c6-4d61-ab87-c3adfb190ea0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "24542f8c-6b0c-4746-a034-f7fb5bc590e9",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/be9fcb5d-3e84-4bf5-8c18-6613d1676802/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/be9fcb5d-3e84-4bf5-8c18-6613d1676802/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "35aa1991-c325-4e58-9fa8-a8acd767d813",
			"parent_table": "block",
			"file_ids": [
				"be9fcb5d-3e84-4bf5-8c18-6613d1676802"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/24542f8c-6b0c-4746-a034-f7fb5bc590e9.png"
		},
		{
			"id": "d5af9518-b1ba-4efc-863c-a5b662f52d0b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"25.09.1990 \n\nc 25 сентября 2025 вырастут цены на тариф"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c8225a61-8331-45f6-a58b-708d06da60e2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "35aa1991-c325-4e58-9fa8-a8acd767d813",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6fa7e67b-12f8-4726-b5ab-d6605b78db70",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/860129a2-a002-43fe-8339-1ffc1c98528d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/860129a2-a002-43fe-8339-1ffc1c98528d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "c7778ae4-a21a-48d6-8217-2f549e664e64",
			"parent_table": "block",
			"file_ids": [
				"860129a2-a002-43fe-8339-1ffc1c98528d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6fa7e67b-12f8-4726-b5ab-d6605b78db70.png"
		},
		{
			"id": "0df2c741-0ae7-4212-9ae9-422931c207e5",
			"type": "callout",
			"properties": {
				"title": [
					[
						"25/09/2024  "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "7bd9d550-7776-4174-8826-7ccef8dda0df",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c7778ae4-a21a-48d6-8217-2f549e664e64",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93455b07-e2b6-4cc2-a59d-8fd66d4043d7",
			"type": "column",
			"content": [
				"0ee018b3-ce36-4c53-9216-46194d0f9b22",
				"d52f381b-473a-4f0a-9038-c6f04ca9d951"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1164f77a-b9cd-4c1e-83df-f5c8506c0282",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fdf13b95-9b68-4efb-88f8-390b5e7774fb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "152449e1-54b5-4487-9ea9-916437e043b4",
			"type": "column",
			"content": [
				"f9c4885e-6e5a-44a5-a66a-453afa2ae6aa",
				"839a1ae8-c9cf-4663-87c1-b591947fe5eb"
			],
			"format": {
				"column_ratio": 0.4999999999999999,
				"copied_from_pointer": {
					"id": "fe088286-3b35-4bd1-aad2-6c23b6a473eb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fdf13b95-9b68-4efb-88f8-390b5e7774fb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ee018b3-ce36-4c53-9216-46194d0f9b22",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/333caddb-23dc-4098-892e-4197a04e3ab3/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/333caddb-23dc-4098-892e-4197a04e3ab3/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "93455b07-e2b6-4cc2-a59d-8fd66d4043d7",
			"parent_table": "block",
			"file_ids": [
				"333caddb-23dc-4098-892e-4197a04e3ab3"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/0ee018b3-ce36-4c53-9216-46194d0f9b22.png"
		},
		{
			"id": "d52f381b-473a-4f0a-9038-c6f04ca9d951",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Читайте в блоге "
					],
					[
						"статью про Заметки ",
						[
							[
								"a",
								"https://notebook.mail.ru/",
								true
							]
						]
					],
					[
						"\n\n"
					],
					[
						"Скачать условия ",
						[
							[
								"h",
								"default"
							],
							[
								"a",
								"https://help.mail.ru/legal/terms/common/privacy",
								true
							]
						]
					],
					[
						"\nв формате .pdf",
						[
							[
								"h",
								"default"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ad28b6f0-ac0b-4cd1-a455-260f2d6ce46c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "93455b07-e2b6-4cc2-a59d-8fd66d4043d7",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9c4885e-6e5a-44a5-a66a-453afa2ae6aa",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d50fd48d-4b8c-4e50-9471-6639ef95cebd/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d50fd48d-4b8c-4e50-9471-6639ef95cebd/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "152449e1-54b5-4487-9ea9-916437e043b4",
			"parent_table": "block",
			"file_ids": [
				"d50fd48d-4b8c-4e50-9471-6639ef95cebd"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f9c4885e-6e5a-44a5-a66a-453afa2ae6aa.png"
		},
		{
			"id": "839a1ae8-c9cf-4663-87c1-b591947fe5eb",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Читайте статью про Заметки \n"
					],
					[
						"на сайте",
						[
							[
								"h",
								"blue"
							],
							[
								"a",
								"https://notebook.mail.ru/",
								true
							]
						]
					],
					[
						" \n\nСкачать "
					],
					[
						"условия",
						[
							[
								"h",
								"blue"
							],
							[
								"a",
								"https://help.mail.ru/legal/terms/common/privacy",
								true
							]
						]
					],
					[
						" в формате .pdf"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d8b6f6ad-a5f1-460a-9111-5b6d57efb4d9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "152449e1-54b5-4487-9ea9-916437e043b4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dcf2fd61-bcb9-44df-8f90-c8de52fc7782",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5ef2e146-e61d-4262-a7d5-f2d63e63b9dc/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5ef2e146-e61d-4262-a7d5-f2d63e63b9dc/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"file_ids": [
				"5ef2e146-e61d-4262-a7d5-f2d63e63b9dc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/dcf2fd61-bcb9-44df-8f90-c8de52fc7782.png"
		},
		{
			"id": "574bc61e-6ffd-4108-a490-30c624a3f03f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы "
					],
					[
						"используем файлы куки",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" и "
					],
					[
						"рекомендательные технологии",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" — с их помощью сайт станет удобнее и предложит то, что вам может быть интересно. Если вы хотите отказаться от использования файлов, измените настройки браузера.\n\nМы "
					],
					[
						"используем файлы куки",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" и "
					],
					[
						"рекомендательные технологии",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" — с ними пользоваться сайтом удобнее и легче. Отказаться от использования файлов вы можете в настройках браузера.\n\nМы "
					],
					[
						"используем файлы куки",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" и "
					],
					[
						"рекомендательные технологии",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" ",
						[
							[
								"h",
								"blue"
							]
						]
					],
					[
						"— они помогают понять, что вам интересно, и делают работу на сайте удобнее. Отказаться от использования файлов вы можете в настройках браузера.\n\nМы "
					],
					[
						"используем файлы куки",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" и "
					],
					[
						"рекомендательные технологии",
						[
							[
								"h",
								"default"
							]
						]
					],
					[
						" — они помогают понять, что вам интересно, и делают работу на сайте удобнее. Если вы хотите отказаться от использования файлов, измените настройки браузера."
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c099bc3a-3362-43e5-83e3-e77b211a632e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d21336ae-ecfc-4130-a757-19109a89ad74",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Знаки",
			"id": "b7864cd6-2e21-495a-9b51-ae4ed7f1f1fd"
		},
		{
			"title": "Слова",
			"id": "0d47c60d-34b1-4653-96fe-e1abd244a543"
		},
		{
			"title": "Оформление   ",
			"id": "ce76612e-ef9c-46fe-8fee-7731d44001f2"
		}
	]
}} />
);

export default NotionVoiceAndToneClean;
